export const sampleKeywords = {
   "keywords": [
            "Modular packaging system",
            "Environmental sensors",
            "Real-time monitoring",
            "Supply chain integrity",
            "Low-power connectivity",
            "Compliance logging",
            "Reusable sensor closure",
            "Industrial deployment"
        ]
}

export const dataSources = {
  Website: [
    "https://explodingtopics.com/blog/ai-market-size-stats",
    "https://www.heatseeker.ai/blog-posts/how-ai-is-changing-the-competitor-analysis-game",
    "https://www.panoramata.co/benchmark-marketing/ai-competitive-analysis",
    "https://www.leewayhertz.com/ai-for-competitive-analysis/",
    "https://www.reddit.com/r/truegaming/comments/gh14hl/ai_ranking_concept_in_competitive_multiplayer/",
    "https://unity.com/blog/industry-trends-report-2025",
    "https://www.siegelgale.com/beyond-the-screen-how-immersive-experiences-will-change-gaming/",
    "https://finance.yahoo.com/news/virtual-reality-growth-trends-report-123200647.html",
    "https://www.reddit.com/r/virtualreality/comments/1dpa10i/vr_devs_is_vr_actually_growing/",
    "https://www.reddit.com/r/videogames/comments/1iwxwrp/why_is_the_gaming_industry_taking_so_long_to/",
    "https://builtin.com/articles/future-of-gaming",
  ],
  Publication: [
    "https://www.abiresearch.com/news-resources/chart-data/report-artificial-intelligence-market-size-global",
    "https://www.grandviewresearch.com/industry-analysis/artificial-intelligence-ai-market",
    "https://www.fortunebusinessinsights.com/industry-reports/artificial-intelligence-market-100114",
    "https://www.grandviewresearch.com/industry-analysis/immersive-entertainment-market-report",
    "https://www.marketsandmarkets.com/Market-Reports/immersive-vr-market-201528031.html",
    "https://www.globenewswire.com/news-release/2024/11/15/2981909/0/en/Immersive-VR-Market-Set-to-Grow-with-26-5-CAGR-Reaching-USD-128-92-Billion-by-2032-PMR.html",
    "https://www.precedenceresearch.com/immersive-technology-market",
    "https://www.gminsights.com/industry-analysis/virtual-reality-in-gaming-market",
    "https://www.grandviewresearch.com/industry-analysis/virtual-reality-in-gaming-market",
    "https://www.imarcgroup.com/virtual-reality-gaming-market",
    "https://www.fortunebusinessinsights.com/industry-reports/virtual-reality-gaming-market-100271",
  ],
  Scholar: [
    "https://www.mckinsey.com/capabilities/quantumblack/our-insights/the-state-of-ai",
    "https://www.mckinsey.com/capabilities/quantumblack/our-insights/the-state-of-ai-in-2023-generative-ais-breakout-year",
  ],
  Government: [],
  Organisation: [
    "https://www.bakertilly.com/insights/ai-trends-2023-recap-and-insights-for-whats-to-come",
    "https://www.gartner.com/en/articles/what-s-new-in-artificial-intelligence-from-the-2023-gartner-hype-cycle",
    "https://www.statista.com/outlook/tmo/artificial-intelligence/worldwide",
    "https://www.precedenceresearch.com/artificial-intelligence-market",
    "https://www.nu.edu/blog/ai-statistics-trends/",
    "https://www.restack.io/p/ai-in-gaming-answer-competitive-analysis-cat-ai",
    "https://www.quora.com/How-is-AI-reshaping-the-landscape-of-competitive-gaming",
    "https://www.linkedin.com/pulse/game-changing-role-ai-competitive-esports-anybraingg-arhyf",
    "https://www.insightaceanalytic.com/report/ai-in-gaming-market/2748",
    "https://www.marketresearchfuture.com/reports/immersive-technology-in-gaming-industry-market-12131",
    "https://www.mordorintelligence.com/industry-reports/immersive-experiment-market",
    "https://www.promarketreports.com/reports/immersive-technology-in-gaming-industry-market-8215",
    "https://www.statista.com/outlook/amo/media/games/worldwide",
    "https://www.bcg.com/press/12december2024-future-of-global-gaming-industry",
  ],
};

export const reportTemplates = {
  sections: {
    "1": {
      body: "Highlight the main objectives, methodology, and high-level insights.",
      title: "Executive Summary",
      summary: "A brief overview of the key findings and recommendations.",
      subsections: {
        "1.1": {
          body: "Detailed points summarizing the critical insights.",
          title: "Key Findings",
          summary: "Main takeaways from the analysis.",
        },
      },
    },
    "2": {
      body: "In-depth examination of market trends, growth drivers, and challenges.",
      title: "Market Analysis",
      summary: "An analysis of the current market landscape for AI in gaming.",
      subsections: {
        "2.1": {
          body: "Detailed discussion on technological advancements, customer preferences, and industry shifts.",
          title: "Market Trends",
          summary: "Current and emerging trends in the AI gaming industry.",
        },
      },
    },
    "3": {
      body: "Analysis of competitors' strengths, weaknesses, opportunities, and threats (SWOT).",
      title: "Competitive Landscape",
      summary: "Evaluation of top competitors in the AI gaming market.",
      subsections: {
        "3.1": {
          body: "Detailed information on competitors' products, market positioning, strategies, and performance.",
          title: "Competitor Profiles",
          summary: "Profile of key competitors.",
        },
      },
    },
    "4": {
      body: "Assessment of potential markets based on size, growth rate, and alignment with company capabilities.",
      title: "Opportunities for Market Entry",
      summary: "Identification of new market opportunities for Quantum Games.",
      subsections: {
        "4.1": {
          body: "Detailed demographics, behavior patterns, and needs of target segments.",
          title: "Target Segments",
          summary: "Specific segments within the new markets that offer high potential.",
        },
      },
    },
    "5": {
      body: "Recommendations based on data analysis and market insights.",
      title: "Strategic Recommendations",
      summary:
        "Actionable strategies for entering new markets and improving competitive positioning.",
      subsections: {
        "5.1": {
          body: "Step-by-step plan including marketing tactics, partnerships, and resource allocation.",
          title: "Market Entry Strategies",
          summary: "Suggested approaches for entering identified markets.",
        },
      },
    },
    "6": {
      body: "Analysis of pricing models used by competitors and recommendations for Quantum Games.",
      title: "Pricing Strategy Analysis",
      summary: "Evaluation of current pricing strategies in relation to market conditions.",
      subsections: {
        "6.1": {
          body: "Detailed comparison including price points, value propositions, and customer perceptions.",
          title: "Competitive Pricing Models",
          summary: "Overview of pricing strategies used by top competitors.",
        },
      },
    },
    "7": {
      body: "Analysis of customer preferences",
      title: "Customer Insights",
      summary: "Insights derived from customer feedback",
      subsections: {
        "7.1": {
          body: "Key takeaways from feedback",
          title: "Feedback Summary",
          summary: "Overview of customer feedback",
        },
      },
    },
  },
};

export const companyDiligenceAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message:
        "Hi there! 👋 I'm your Company Diligence Agent, here to help you build a comprehensive company report. To start, what's the **name of your company**?",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "Ziteo",
      assistant_message:
        "Thanks! Please **upload your pitch deck and any additional resources** that provide insight into your product, business model, or market opportunity.",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message:
        '{"pitchdeck_summary":[["","Great! I’ve reviewed the uploaded materials and extracted the following highlights. Let me know if you’d like to add or edit anything:"],["Company Name","Ziteo"],["Problem","Limited access to high-resolution SPECT imaging in oncology, cardiology, and neurology"],["Solution","Portable SPECT system with integrated ultrasound; <5mm spatial resolution\\n"],["Business Model","Direct sales to hospitals/clinics with recurring revenue from service contracts\\n"],["Competitive Edge","Superior image resolution, cost-effective ($750K/unit), and portable\\n"],["Market Opportunity"," Growing demand for diagnostic imaging driven by cancer prevalence, aging population, and global health investments\\n"],["Milestones","FDA clearance in H1 Year 1; 50 units deployed in U.S. hospitals; EU/Asia expansion by Year 3\\n"],["","Ready to move on?"]]}',
      assistant_message: "@@Edit Summary@@\n- @@Yes, Looks Good@@",
      json_datasources: {},
      json_report: {
        Team: {
          CEO: ["Jane Doe (10+ years in clean tech, ex-SolarCity)"],
          COO: ["Emily Johnson (Operations lead, previously at Tesla)"],
          CTO: ["John Smith (AI expert, PhD in Machine Learning)"],
        },
        Founded: ["2021"],
        Mission: ["To make clean energy accessible, affordable, and efficient for everyone."],
        Problem: {
          "Pain Point": [
            "Homeowners face rising energy costs, while environmental regulations demand more sustainable solutions.",
          ],
          "Current Issue": [
            "Over 70% of homes still rely on non-renewable energy, leading to inefficiencies and high carbon footprints.",
          ],
          "Customer Impact": [
            "High costs, environmental concerns, lack of easy solutions for energy management.",
          ],
        },
        Tagline: ["Empowering homes with clean energy"],
        Location: ["San Francisco, CA"],
        Solution: {
          Product: ["Solar-powered smart home energy systems"],
          "Key Features": [
            "AI-driven energy optimization",
            "Seamless integration with existing home systems",
            "Scalable for commercial use",
          ],
          "Unique Value Proposition": [
            "EcoTech reduces energy bills by up to 30%, while enabling homes to lower their carbon emissions.",
          ],
        },
        Traction: {
          Milestones: [
            "1,500 units sold in the first 12 months.",
            "Partnership with 3 utility providers.",
            "$1.2M in annual recurring revenue (ARR) from subscriptions.",
          ],
          "Customer Feedback": ["Average customer savings of 25% on energy bills."],
        },
        "Company Name": ["Ecotech Innovations"],
        "Business Model": {
          "Revenue Streams": [
            "Direct Sales: Solar-powered systems sold to homeowners and businesses.",
            "Subscription: Monthly energy management services via AI-driven software.",
            "Partnerships: Partnering with utility companies to provide grid support.",
          ],
        },
        "Financial Overview": {
          Funding: {
            Raising: ["$5M for scaling manufacturing and marketing"],
            "Use of Funds": {
              Marketing: ["30%"],
              Manufacturing: ["60%"],
              "Operational Costs": ["10%"],
            },
          },
          Revenue: ["$2.5M (2023 projected)"],
          "Burn Rate": ["$50k per month"],
        },
        "Market Opportunity": {
          "Growth Rate": ["8.9% CAGR in the smart home energy management sector."],
          "Market Size": [
            "$300 billion global smart home market, with a $50 billion subset for clean energy solutions.",
          ],
          "Target Audience": [
            "Homeowners and commercial properties looking to reduce energy costs and carbon footprints.",
          ],
        },
        "IP and Defensibility": {
          Patents: [
            "Two patents filed for AI optimization algorithms and energy storage technology",
          ],
          "Proprietary Software": ["Real-time energy management"],
        },
        "Competitive Landscape": {
          Competitors: ["Tesla Powerwall", "Sunrun", "Vivint Solar"],
          Differentiation: [
            "AI-driven optimization and seamless integration with existing home systems give EcoTech a unique edge over competitors.",
          ],
        },
        "Go-to-Market Strategy": {
          Channels: [
            "Direct-to-consumer via digital marketing.",
            "Partnerships with home builders and utility companies.",
            "B2B for commercial installations.",
          ],
          "Lifetime Value (LTV)": ["$900"],
          "Customer Acquisition Cost (CAC)": ["$120"],
        },
        "Market Expansion and Scalability": {
          "Near-term Goals": ["Expand into Europe and Asia-Pacific within eighteen months"],
          "Long-term Vision": ["Become a global leader in sustainable smart home solutions"],
        },
      },
      filename_url: {
        "Ziteo Competitive Landscape Revised.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Yes, Looks Good",
      assistant_message:
        "Next, what stage is your company currently in?\n\n- @@Pre-Seed (Pre-Revenue)@@\n- @@Seed (Early-Revenue)@@\n- @@Early Stage (Series A)@@\n- @@Growth (Series B)@@\n- @@Scaling (Series C)@@\n- @@Mature / Exit Stage@@",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6107,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: "Pre-Seed (Pre-Revenue)",
      assistant_message:
        "Now, please select your preferred diligence level:\n\n- @@Quick Screening – High-level overview across key categories@@\n- @@Deep Dive – Detailed report across strategy, IP, operations, and financials@@",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6108,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: "Quick Screening",
      assistant_message: `Perfect. I’ll focus on the following analysis areas:\n\n- 📈 Market Opportunity
- ⚔️ Competitive Differentiation
- 🧪 Product Viability
- 👥 Founding Team Overview
- 🚀 Go-to-Market Strategy
- 📢 Customer Validation
- 💰 Revenue Model
- 🤝 Partnerships and Alliances
- 🛡️ Regulatory and Compliance
- 🏭 Operational Efficiency
- 🧱 Product Scalability
- ⏱️ Time to Market
- 💡 Technology & IP\n\n Would you like to customize or prioritize any sections?
`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6109,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: "No, this works. Go ahead",
      assistant_message: `Thanks! Your custom diligence report will include:\n\n
- 📌 **Executive Summary**
- 📈 **Market Trends & Growth Projections**
- ⚔️ **Competitor Benchmarking Matrix**
- 🧠 **Technology and Product Differentiation**
- 🚀 **Go-to-Market & Revenue Model Review**
- 📊 **SWOT Analysis & Strategic Recommendations**\n\nYou’ll get notified as soon as the report is complete and ready to view.
\n\n@@Submit@@
`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
  ],
};

export const technologyRndAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hi there! 👋 I’m your Technology & R&D Agent, here to help assess your technology positioning, R&D strategy, and commercialization outlook.

To begin, what are your primary objectives for this analysis?  
For example:  
- Evaluate how your technology stacks up against key competitors  
- Identify innovation trends in your industry  
- Understand IP strategy and commercialization risks
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        " We want to evaluate the competitive landscape, innovation trends, revenue potential, and commercialization strategy for our Brava orthodontic system compared to Invisalign and InBrace.",
      assistant_message: `Great, got it! So your main objectives are:
- Evaluate the competitive landscape
- Track innovation trends in orthodontics
- Forecast revenue potential
- Assess commercialization strategy compared to top competitors

Let's move to the next step.
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Please upload any key documents that describe your company and product. This might include:
- Your pitch deck
- A company one-pager
- Technical overviews or IP summaries
- Recent traction or milestone reports

Once uploaded, I’ll extract the key information and confirm it with you before we move forward.

`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message:
        '{"pitchdeck_summary":[["","Thanks for uploading your pitch deck! Here’s a summary of the key information extracted:"],["Company Name","Narratize AI"],["Product"," Generative AI platform for structured content creation in enterprise R&D, life sciences, and innovation workflows"],["Problem Solved","Manual documentation slows IP generation, regulatory submissions, and internal knowledge workflows"],["Technology and IP:","- Ontology-structured LLMs \\n- Proprietary narrative engine \\n - Knowledge graph for technical content generation"],["Country","United States"],["Stage","Post-launch, with active enterprise contracts\\n"],["Funding","~$2M raised from Kubera and HearstLab\\n"],["Business Model","SaaS (ARR-driven, enterprise-focused"],["Market Size","$803B by 2033 (CAGR: 46.5%)"],["Competitors","Jasper AI, Hugging Face, CTRL-Labs, Granulate"],["Potential Strategic Acquirers:", "Microsoft, Salesforce, Palantir, ServiceNow, Databricks"],["","Does everything here look accurate to you?"],["","Let me know if you would like to revise or add anything. If all looks good, we’ll move on to your short- and long-term fundraising goals."]]}',
      assistant_message: "@@Edit Summary@@\n- @@Yes, Looks Good@@",
      json_datasources: {},
      json_report: {
        Team: {
          CEO: ["Jane Doe (10+ years in clean tech, ex-SolarCity)"],
          COO: ["Emily Johnson (Operations lead, previously at Tesla)"],
          CTO: ["John Smith (AI expert, PhD in Machine Learning)"],
        },
        Founded: ["2021"],
        Mission: ["To make clean energy accessible, affordable, and efficient for everyone."],
        Problem: {
          "Pain Point": [
            "Homeowners face rising energy costs, while environmental regulations demand more sustainable solutions.",
          ],
          "Current Issue": [
            "Over 70% of homes still rely on non-renewable energy, leading to inefficiencies and high carbon footprints.",
          ],
          "Customer Impact": [
            "High costs, environmental concerns, lack of easy solutions for energy management.",
          ],
        },
        Tagline: ["Empowering homes with clean energy"],
        Location: ["San Francisco, CA"],
        Solution: {
          Product: ["Solar-powered smart home energy systems"],
          "Key Features": [
            "AI-driven energy optimization",
            "Seamless integration with existing home systems",
            "Scalable for commercial use",
          ],
          "Unique Value Proposition": [
            "EcoTech reduces energy bills by up to 30%, while enabling homes to lower their carbon emissions.",
          ],
        },
        Traction: {
          Milestones: [
            "1,500 units sold in the first 12 months.",
            "Partnership with 3 utility providers.",
            "$1.2M in annual recurring revenue (ARR) from subscriptions.",
          ],
          "Customer Feedback": ["Average customer savings of 25% on energy bills."],
        },
        "Company Name": ["Ecotech Innovations"],
        "Business Model": {
          "Revenue Streams": [
            "Direct Sales: Solar-powered systems sold to homeowners and businesses.",
            "Subscription: Monthly energy management services via AI-driven software.",
            "Partnerships: Partnering with utility companies to provide grid support.",
          ],
        },
        "Financial Overview": {
          Funding: {
            Raising: ["$5M for scaling manufacturing and marketing"],
            "Use of Funds": {
              Marketing: ["30%"],
              Manufacturing: ["60%"],
              "Operational Costs": ["10%"],
            },
          },
          Revenue: ["$2.5M (2023 projected)"],
          "Burn Rate": ["$50k per month"],
        },
        "Market Opportunity": {
          "Growth Rate": ["8.9% CAGR in the smart home energy management sector."],
          "Market Size": [
            "$300 billion global smart home market, with a $50 billion subset for clean energy solutions.",
          ],
          "Target Audience": [
            "Homeowners and commercial properties looking to reduce energy costs and carbon footprints.",
          ],
        },
        "IP and Defensibility": {
          Patents: [
            "Two patents filed for AI optimization algorithms and energy storage technology",
          ],
          "Proprietary Software": ["Real-time energy management"],
        },
        "Competitive Landscape": {
          Competitors: ["Tesla Powerwall", "Sunrun", "Vivint Solar"],
          Differentiation: [
            "AI-driven optimization and seamless integration with existing home systems give EcoTech a unique edge over competitors.",
          ],
        },
        "Go-to-Market Strategy": {
          Channels: [
            "Direct-to-consumer via digital marketing.",
            "Partnerships with home builders and utility companies.",
            "B2B for commercial installations.",
          ],
          "Lifetime Value (LTV)": ["$900"],
          "Customer Acquisition Cost (CAC)": ["$120"],
        },
        "Market Expansion and Scalability": {
          "Near-term Goals": ["Expand into Europe and Asia-Pacific within eighteen months"],
          "Long-term Vision": ["Become a global leader in sustainable smart home solutions"],
        },
      },
      filename_url: {
        "Narratize_AI_PitchDeck_v3.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Yes, Looks Good",
      assistant_message: `What are your short-term and long-term goals for R&D and tech strategy?

For example: 
- **Short-term**: Optimize product performance, validate ROI, file new patents
- **Long-term**: Build a defensible IP moat, expand into new markets, license your tech`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6107,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Short-Term Goal: Benchmark Brava’s performance and adoption against Invisalign and InBrace.

Long-Term Goal: Expand internationally, build out our IP portfolio, and develop a licensing model for certain regions.`,
      assistant_message: `Perfect. Summarizing:
- **Short-Term**: Competitive benchmarking and adoption analysis
- **Long-Term**: Global expansion, IP moat development, licensing roadmap`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6108,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: "",
      assistant_message: `Let’s now define the key strategic questions we should address.

Please list **3–5 key questions** you'd like this report to answer. You can think about:

-Technology and clinical performance
-IP defensibility and gaps
-Commercialization barriers
-R&D process efficiency
-Emerging innovation areas in orthodontics
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6109,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `1. How does Brava compare to Invisalign and InBrace on clinical outcomes and patient satisfaction?
2. What’s the projected orthodontic market growth through 2028, and which geographies are primed for adoption?
3. What are the biggest regulatory and commercialization hurdles for entering Europe and Asia?
4. How strong is our IP position vs. competitors, and are there untapped innovation areas we should explore?`,
      assistant_message: `Got it! Your key questions are:

1. Competitive performance: technology, outcomes, satisfaction  
2. Market growth and regional opportunity  
3. Regulatory and commercialization hurdles globally  
4. IP strength, whitespace, and innovation strategy  

We’ll base your report around these questions.

`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6110,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `It sounds great! Go ahead`,
      assistant_message: `Thanks for sharing all your inputs! Your custom report will include:

- 📌 **Executive Summary**
- 🧠 **Technology Benchmarking vs. Competitors**
- 📈 **Market Sizing & Segmentation (2023–2028)**
- 📊 **Commercialization Risks & Regulatory Analysis**
- 🧬 **IP Landscape & Innovation White Space**
- 🔬 **Strategic Recommendations for R&D and Licensing**
  
You’ll get notified as soon as the report is complete and ready to view.
@@Submit@@
`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
  ],
};

export const marketStrategyAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hi there! 👋 I’m your Market Strategy Agent. I’m here to help you refine your product-market fit, messaging, and go-to-market strategy.

Let’s start with your primary objectives. For example:

- Identify opportunities for entering new markets
- Evaluate competitive positioning
- Recommend pricing strategies for a specific audience

What would you like to focus on?
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        "We want to deeply understand customer workflows and stakeholder needs within oncology tumor boards—especially around NGS data, clinical decision-making, inefficiencies, and unmet needs—to improve product positioning, messaging, and product-market fit for our ICP.",
      assistant_message: `Got it! Here's a quick confirmation of your objectives:
- Understand workflows and stakeholder needs in oncology tumor boards
- Focus on NGS data, clinical decision-making, and inefficiencies
- Improve positioning, messaging, and product-market fit for your Ideal Customer Profile (ICP)

Shall we continue?
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "Yes",
      assistant_message: `Please upload any documents that capture market or clinical insights relevant to this analysis. These might include:
- Stakeholder interview notes
- Internal research memos or insight decks
- Competitive benchmarking or product feedback summaries
- Notes on workflow inefficiencies or innovation opportunities

Once uploaded, I’ll extract and summarize the key insights to confirm with you before proceeding.

`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[["","Thanks! I've reviewed your uploaded document. Here's a summary of the key insights:"],

["Tumor Board Composition:", "Distinct structures between academic centers and community practices"],

["Clinical Inefficiencies:", "Delays in case review, fragmented decision support, lack of unified tools"],

["Workflow Breakdown:","Issues with timing of NGS report availability and decision turnaround"],

["Tool & Tech Preferences:","Interest in simplified reporting, integrated trial matching, and EMR interoperability"],

["Innovation Opportunities:","Strong demand for AI-enhanced reporting, workflow optimization, and real-time data delivery"],
["Does this summary look accurate to you?","If everything looks good, we’ll proceed to define your short- and long-term product or market goals."]]}`,
      assistant_message: "@@Edit Summary@@\n- @@Looks Good@@",
      json_datasources: {},
      json_report: {
        Team: {
          CEO: ["Jane Doe (10+ years in clean tech, ex-SolarCity)"],
          COO: ["Emily Johnson (Operations lead, previously at Tesla)"],
          CTO: ["John Smith (AI expert, PhD in Machine Learning)"],
        },
        Founded: ["2021"],
        Mission: ["To make clean energy accessible, affordable, and efficient for everyone."],
        Problem: {
          "Pain Point": [
            "Homeowners face rising energy costs, while environmental regulations demand more sustainable solutions.",
          ],
          "Current Issue": [
            "Over 70% of homes still rely on non-renewable energy, leading to inefficiencies and high carbon footprints.",
          ],
          "Customer Impact": [
            "High costs, environmental concerns, lack of easy solutions for energy management.",
          ],
        },
        Tagline: ["Empowering homes with clean energy"],
        Location: ["San Francisco, CA"],
        Solution: {
          Product: ["Solar-powered smart home energy systems"],
          "Key Features": [
            "AI-driven energy optimization",
            "Seamless integration with existing home systems",
            "Scalable for commercial use",
          ],
          "Unique Value Proposition": [
            "EcoTech reduces energy bills by up to 30%, while enabling homes to lower their carbon emissions.",
          ],
        },
        Traction: {
          Milestones: [
            "1,500 units sold in the first 12 months.",
            "Partnership with 3 utility providers.",
            "$1.2M in annual recurring revenue (ARR) from subscriptions.",
          ],
          "Customer Feedback": ["Average customer savings of 25% on energy bills."],
        },
        "Company Name": ["Ecotech Innovations"],
        "Business Model": {
          "Revenue Streams": [
            "Direct Sales: Solar-powered systems sold to homeowners and businesses.",
            "Subscription: Monthly energy management services via AI-driven software.",
            "Partnerships: Partnering with utility companies to provide grid support.",
          ],
        },
        "Financial Overview": {
          Funding: {
            Raising: ["$5M for scaling manufacturing and marketing"],
            "Use of Funds": {
              Marketing: ["30%"],
              Manufacturing: ["60%"],
              "Operational Costs": ["10%"],
            },
          },
          Revenue: ["$2.5M (2023 projected)"],
          "Burn Rate": ["$50k per month"],
        },
        "Market Opportunity": {
          "Growth Rate": ["8.9% CAGR in the smart home energy management sector."],
          "Market Size": [
            "$300 billion global smart home market, with a $50 billion subset for clean energy solutions.",
          ],
          "Target Audience": [
            "Homeowners and commercial properties looking to reduce energy costs and carbon footprints.",
          ],
        },
        "IP and Defensibility": {
          Patents: [
            "Two patents filed for AI optimization algorithms and energy storage technology",
          ],
          "Proprietary Software": ["Real-time energy management"],
        },
        "Competitive Landscape": {
          Competitors: ["Tesla Powerwall", "Sunrun", "Vivint Solar"],
          Differentiation: [
            "AI-driven optimization and seamless integration with existing home systems give EcoTech a unique edge over competitors.",
          ],
        },
        "Go-to-Market Strategy": {
          Channels: [
            "Direct-to-consumer via digital marketing.",
            "Partnerships with home builders and utility companies.",
            "B2B for commercial installations.",
          ],
          "Lifetime Value (LTV)": ["$900"],
          "Customer Acquisition Cost (CAC)": ["$120"],
        },
        "Market Expansion and Scalability": {
          "Near-term Goals": ["Expand into Europe and Asia-Pacific within eighteen months"],
          "Long-term Vision": ["Become a global leader in sustainable smart home solutions"],
        },
      },
      filename_url: {
        "Oncology_TumorBoard_WorkflowInsights.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Looks Good",
      assistant_message: `Now let’s define your strategic goals. What are your:

- **Short-Term Goals**? (e.g., segmentation, message testing)
- **Long-Term Goals**? (e.g., product development, market expansion). Also, please describe the specific segments you're aiming to target (e.g., demographics, behavior, geography).`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6107,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Short-Term: Segment tumor board behaviors and needs across different institution types.\n
Long-Term: Design better precision oncology tools and support services aligned with clinical workflows and efficiency gaps.`,
      assistant_message: `Thanks. Here’s the breakdown:
- **Short-Term**: Understand tumor board behaviors by institution type
- **Long-Term**: Build oncology tools that align with clinical gaps and workflows`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6107,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: ``,
      assistant_message: `Now, let’s move into your burning questions..

Please list 3–5 key questions you’d like the report to answer.

Think about: 

- Workflow insights
- Gaps in clinical decision support
- Stakeholder analysis
- Areas where your solution can create real differentiation`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6108,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Let’s answer:

1. What are the key differences in tumor board composition between AMCs and community practices?
2. What inefficiencies exist in case review and clinical reporting workflows?
3. What technological gaps could be addressed with new tools or data platforms?
4. What stakeholder roles are most underserved or lacking support?`,
      assistant_message: `Perfect. Here’s the question summary:

1. Composition differences between tumor boards in academic vs. community settings
2. Key inefficiencies in review/reporting workflows
3. Unmet needs where tech tools (AI, integration) could help
4. Underserved stakeholder roles in tumor board processes

Let’s now round out Step 4 by gathering additional competitive and market alignment insights.
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6109,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Sure. Let’s do it`,
      assistant_message: `To complete this step, please help with these final inputs:

🥊 Competitor & Industry Landscape
- Who are your main competitors?
- What are their strengths or weaknesses?
- How do you currently differentiate?

💰 Pricing & Growth Drivers
- What pricing structure are you exploring?
- What’s your target profitability or market share goal?
- What external forces (tech, policy, behavior) are driving growth?

🔧 Product-Market Alignment
- What feedback have you received from real users?
- Have you made any changes to address unmet needs?
- What feature or value is resonating most?
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6110,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `We’re still finalizing pricing but know affordability and value-based features are key.\n
Competitors include companies focused on oncology workflow tools, but most don't integrate with tumor board decision-making.\n
We've heard from oncologists that turnaround time and data clarity are the biggest pain points.\n
We’re iterating toward better real-time data delivery and trial matching tools.`,
      assistant_message: `Got it. You’re aiming to:

- Differentiate via tumor board alignment and speed of decision support
- Offer real-time data tools that improve trial access and clinical clarity
- Compete on user experience rather than just feature set
- Align pricing with value to hospitals and clinicians
`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6111,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Yes. You’re right`,
      assistant_message: `Thanks for all your inputs! Your market strategy report will include:

- 📌 Executive Summary
- 🧠 Stakeholder & Workflow Mapping
- 📈 Behavioral Segmentation by Institution Type
- 📊 Competitive Landscape & Market Gap Analysis
- 💬 Positioning & Messaging Frameworks
- 📎 Strategic Recommendations for PMF & GTM Alignment

You’ll get notified once the report is complete and ready to view.
\n\n@@Submit@@
`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
  ],
};

export const corporateVentureAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hello! 👋 I’m your Corporate Venture Capital Agent. I'm here to help assess strategic commercialization opportunities and identify growth pathways through partnerships, investments, or acquisitions.

To get started, what are your primary objectives for this analysis? Some common goals include:

- Identifying joint venture or acquisition opportunities
- Mapping investment-worthy sectors and startups
- Evaluating partnership potential for scalability

What are you hoping to achieve?
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        "We want to assess the full commercialization opportunity for BlueIQ's passive acoustic sensing technologies across marine mammal conservation (aquariums), maritime ports, and defense. This includes TAM/SAM/SOM, ICPs, technology adoption drivers/barriers, and go-to-market strategies.",
      assistant_message: `Got it. Here’s a summary of your objectives:
- Assess commercialization potential of BlueIQ’s passive acoustic sensing platform
- Focus across three verticals: aquariums, maritime ports, and defense
- Analyze TAM/SAM/SOM, ICPs, adoption drivers/barriers, GTM strategy

Let’s move on.
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "Go ahead",
      assistant_message: `Please upload any documents that describe your product, vertical-specific use cases, and value proposition. This might include:
- A product overview or technical brief
- Market segmentation decks
- Go-to-market or positioning memos
- Regulatory readiness notes

Once uploaded, I’ll extract the key insights and confirm them with you before moving forward.

`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[["","Thanks for uploading the document! Here's a summary of what I’ve extracted"],

["Product:", "Passive acoustic sensing platform"],

["Verticals & Use Cases:",
"Aquariums: Enhance animal welfare, support public education, and deepen visitor engagement\\nCommercial Ports: Monitor underwater noise, ensure environmental compliance, and optimize port operations\\nDefense Agencies: Enable coastal surveillance and submersible activity detection"],
[
"Market Strategy:","Defined behavioral profiles and ICP segmentation for each sector\\nOutlined regulatory hurdles and operational barriers\\nValue props include data accuracy, deployability, and system adaptability\\nCompetitive landscape and differentiation factors analyzed per vertical"],
["Does this summary look accurate to you?",
"Let me know if there’s anything you'd like to revise or add. If all looks good, we’ll move on to your short- and long-term commercialization goals."]]}`,
      assistant_message: "@@Edit Summary@@\n- @@Looks Good@@",
      json_datasources: {},

      filename_url: {
        "BlueIQ_VerticalStrategyOverview.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Looks Good",
      assistant_message: `Let’s now define your **short-term and long-term goals**. Also, if you have any key criteria for evaluating M&A targets, joint ventures, or investment opportunities (e.g., revenue, IP, regional presence), feel free to include them.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6107,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Short-Term: Prioritize market entry and customer targeting by vertical.
Long-Term: Build a scalable commercialization roadmap with strong positioning, compliance readiness, and tailored value props for each vertical.`,
      assistant_message: `Great. Summary:\n
- **Short-Term:** Vertical-specific customer acquisition & GTM
- **Long-Term:** Scalable roadmap, compliance alignment, and strategic differentiation

Would you like to specify any M&A/partnership evaluation criteria now, or shall we move to the next step?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6108,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: "Let’s move on",
      assistant_message: `Please list 3–5 strategic questions you want this report to answer.\n
Some examples:

- What’s the market size across each target segment?
- What are your ICPs’ biggest needs or pain points?
- What barriers or regulatory dynamics could affect adoption?
- How should you frame your unique value proposition in a competitive market?
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6109,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Let’s answer:

1. What are the market size and growth projections for aquariums, maritime ports, and defense?
2. What are the ICPs’ pain points and value drivers in each vertical?
3. What regulatory frameworks and entry barriers should we prepare for?
4. How can BlueIQ position itself competitively and secure early adoption?
`,
      assistant_message: `Perfect. Your key questions are:

1. Market sizing and growth outlook (TAM/SAM/SOM)
2. Behavioral and strategic needs of each vertical's ICPs
3. Regulatory environments and barriers to entry
4. Value prop positioning and early adoption enablers

Would you also like to highlight any risks or opportunities we should factor in?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6110,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Yes. Go ahead`,
      assistant_message: `To complete the foundation for this report, here are a few final (optional) inputs you can provide:

**Risks & Opportunities**
- Are there integration or overlap risks with potential M&A targets?
- Are there IP monetization or partnership innovation opportunities?
- Are there adjacent sectors or startups you want us to watch?

**IP & Licensing (if applicable)**
- Do you have any existing or planned patents relevant to this platform?
- Are you exploring licensing opportunities with governments, ports, or NGOs?
Would benchmarking against competitor IP landscapes be helpful?
`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6111,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Let’s skip this for now and proceed.`,
      assistant_message: `Thanks for all your input! Your corporate venture capital report will include:

- 📌 Executive Summary
- 📈 TAM/SAM/SOM and Market Growth Projections by Vertical
- 👥 ICP Profiles and Strategic Buyer Behavior Analysis
- ⚠️ Regulatory Barriers, Entry Timing, and Adoption Risks
- 🚀 GTM and Value Proposition Strategy per Vertical
- 🤝 Recommendations on Strategic Partnerships & Commercialization Pathways

You’ll get notified once the report is complete and ready to view.
\n\n@@Submit@@
`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
  ],
};

export const productEngAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hi there! 👋 I’m your Product & Engineering Agent. I'm here to help guide your product refinement strategy based on user workflows, technology usage, and engineering feasibility.

To begin, what are your primary objectives for this report?
\nSome examples:

- Identify user preferences to guide product design
- Evaluate tool usage patterns and clinical workflows
- Identify areas for redesign, optimization, or compliance risks
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        "We want to define and deeply understand the customer archetypes (ICPs) within oncology tumor boards—including their workflow needs, tool usage patterns (e.g., NGS, EMRs, LIMS), decision-making influences, and technology gaps—to guide product-market fit and clinical adoption.",
      assistant_message: `Great. Here’s a summary of your goals:
-Define oncology tumor board ICPs
- Understand tool usage patterns and workflow breakdowns
- Identify decision-making influence
- Highlight unmet needs and tech gaps for PMF and adoption

Let’s proceed.
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "Great! proceed it now",
      assistant_message: `Please upload any relevant documents that include insights into product usage, user behavior, or decision-making context. This could include:
- Stakeholder research or interview notes
- Workflow breakdowns or UX audit summarie
- Product feedback or adoption data
- Clinical platform or integration analysis

Once uploaded, I’ll extract and summarize the key contextual insights.
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-05T10:57:35.540176",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[["","Thanks! I’ve reviewed the uploaded document. Here’s a summary of the key contextual details extracted:"],

["ICP Segmentation:" ,"Two core customer groups — Academic Medical Centers (AMCs) and Community Practices"],

["Current Tools in Use:", 
"NGS Platforms: Illumina, DNANexus, Syapse\\nTrial Matching: MatchMiner, Watson"],

["Key Decision Criteria:", "Accuracy, user interface quality, ease of integration, vendor support"],

["Pain Points Identified:",
"Overly complex user interfaces\\nDelays in workflow execution\\nEHR/EMR system fragmentation"],

["Current Tools in Use:",
"Predictive analytics for proactive decision support\\nReal-time reporting\\nSimplified UI\\nCloud-based scalability for broader deployment"],
["Does this summary look accurate to you?",
"Let me know if anything needs to be revised. If all looks good, we’ll move on to your short- and long-term product or engineering goals."]]}`,
      assistant_message: "@@Edit Summary@@\n- @@Looks Good@@",
      json_datasources: {},

      filename_url: {
        "TumorBoard_Insights_InternalMemo.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Looks Good",
      assistant_message: `Please share your:

- **Short-term goals** (e.g., prototype refinement, workflow modeling)
- **Long-term goals** (e.g., GTM alignment, scalability, roadmap integration)

Also include any **design considerations** or must-haves you’re tracking.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6107,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Short-Term: Prioritize market entry and customer targeting by vertical.
Long-Term: Build a scalable commercialization roadmap with strong positioning, compliance readiness, and tailored value props for each vertical.`,
      assistant_message: `Great. Summary:
- **Short-Term**: Build detailed ICPs and workflow-driven UX profiles
- **Long-Term**: Refine product and GTM based on real-world clinical operations

Next, let’s frame your burning questions.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6108,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: "Let’s move to the next step",
      assistant_message: `Please list 3–5 critical questions you want this report to answer. Think about:
- Tool usage differences across settings
- UX expectations and decision-making logic
- Integration and performance bottlenecks
- Opportunities for improvement
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6109,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Let’s answer:

1. What are the current tools used by AMCs vs. community practices for NGS analysis and trial matching?
2. What are the top decision criteria (accuracy, UI, integration, cost, support)?
3. What inefficiencies and unmet needs exist in current tumor board workflows?
5. What improvements do stakeholders want in future tools for precision oncology?
`,
      assistant_message: `Noted. Here's a recap:

1. Tool comparisons by institution type
2. Ranked feature/UX priorities from stakeholder POV
3. Workflow pain points and inefficiencies
4. Desired improvements for clinical tech adoption

Now, let’s move to some additional engineering-focused input areas`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6110,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Let’s move now`,
      assistant_message: `To help refine technical priorities, could you also share:

🔬 Prototype Performance & Testing
- Have you benchmarked the prototype vs. current standards?
- Any usability or performance insights from early testers?

🛡️ Compliance & Safety
- Are you aligned with relevant clinical data security or device standards (e.g., HIPAA, ISO 13485)?
- Any known gaps or plans for compliance improvements?

⚙️ Product Reliability & Engineering Efficiency
- Any recurring performance issues or failure points?
- Strategies for improving system responsiveness, uptime, or scalability?
`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
    {
      id: 6111,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `We’re pre-prototype but gathering early qualitative feedback.
 We plan to align with HIPAA and oncology device standards, but haven’t done formal audits yet.
Performance concerns include:
- UI latency during multi-patient case reviews
- Difficult integration with hospital EMRs
- Need for flexible, cloud-first architecture with fast query response`,

      assistant_message: `Perfect. I’ve noted:

- Pre-prototype stage with qualitative data
- HIPAA-aligned roadmap in progress
- Engineering priorities: latency reduction, EMR-friendly integration, scalable cloud backend

Let’s finalize the deliverable.
`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },

    {
      id: 6112,
      user_id: "272",
      thread_id: "1538",
      step: 4,
      user_message: `Sure. Let’s do it now`,
      assistant_message: `Thanks for your detailed inputs! Your Product & Engineering report will include:

- 📌 ICP Segmentation by Institution Type (AMC vs. Community)
- 🔄 Workflow Mapping & Tool Usage Patterns
- 📊 Key Decision Criteria & Feature Expectations
- ⚠️ Pain Point Breakdown & UX Bottlenecks
- 🚀 Stakeholder-Driven Feature Wishlist & Innovation Priorities
- 📎 Engineering Recommendations & UX Refinement Strategies\n
You’ll get notified once the report is complete and ready to view.
\n\n@@Submit@@
`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:53.069771",
    },
  ],
};

export const financeStrategyAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hello! 👋 I’m your Finance & Strategy Agent, here to help you assess the financial viability of ParenchyGel and guide your investor readiness efforts.
      \nLet’s begin by defining your core objectives. For example:\n\n- Forecast ROI and investment recovery\n\n- Validate pricing and unit economics\n\n- Optimize go-to-market capital strategy\n\n**What are your goals for this report?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        "We want to validate the financial viability of ParenchyGel by analyzing projected ROI, pricing assumptions, and investment recovery timelines to prepare for investor conversations.",
      assistant_message: "",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 2,
      user_message: "",
      assistant_message: `Thank you! Here's a summary of your objectives:\n\n**📌 Objectives:**\n\n- Validate financial viability of ParenchyGel\n\n- Analyze projected ROI and payback periods\n\n- Assess pricing assumptions\n\n- Determine investment recovery timelines\n\n- Support investor-facing narrative\n\n**Shall we move to the next step?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:09:12.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 2,
      user_message: "Yes",
      assistant_message: `Great! Please upload any supporting documents relevant to this assessment. Suggested materials include:\n\n- 📄 Financial models or unit economics sheets\n\n- 📊 Commercialization strategy or investor decks\n\n- 📁 Product cost structures, pricing models, or market data\n\nOnce received, I’ll review and summarize before we continue.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:09:12.540176",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message:
        "Thanks for the upload! Here's a summary of key insights extracted from the document:\n\n📄 **Document Highlights: ** \n\n- Outlines pricing strategy ($4,000/unit)\n\n- Market size assumptions and adoption curves\n\n- Cost modeling with scenario analysis\n\n- ROI forecast and breakeven targeting\n\n- Preliminary regulatory and market entry plans\n\n **Let’s now capture your strategic goals.**",
      assistant_message: "@@Edit Summary@@\n- @@Yes, Looks Good@@",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "ParenchyGel_Commercialization Assessment Report.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "",
      assistant_message:
        "Let’s refine the time horizon for your strategy. Please share:\n\n-  Short-Term Goals? (1–3 years)\n\n- Long-Term Goals? (3+ years). \n\n Consider aspects like pricing validation, investment preparation, or market expansion.",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message:
        "Short-Term: Determine whether our current pricing and cost structure supports a 2–3 year \n\nLong-Term: Use this analysis to guide our Series A raise and long-term market expansion plan",
      assistant_message:
        "Perfect. Summary of your goals:\n\n-  🗓️Short-Term: Validate pricing and cost structure for breakeven within 2–3 years\n\n- 🗓️Long-Term: Prepare Series A strategy and roadmap for expansion post-launch \n\n **Ready to move on?**",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Yes",
      assistant_message:
        " Let’s define the key financial questions this report should answer. Here are a few examples to guide you:\n\n-  Will our pricing support 3-year ROI?\n\n- What if COGS or adoption rates shift? \n\n Which capital strategy scales best? \n\n **Please list 3–5 burning questions you'd like covered.**",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message:
        "1. Is our pricing strategy ($4,000/unit) sufficient to reach breakeven in 3 years at our projected SOM?\n 2. How would variations in COGS and adoption rate affect ROI?\n 3. What’s our optimal capital strategy: licensing, co-development, or direct sales?",
      assistant_message:
        " Excellent. We’ll structure the report to answer:\n\n-  📊 Unit Economics: Can $4,000/unit sustain a 3-year breakeven at projected SOM?\n\n- 📈 Sensitivity Modeling: How do COGS and adoption scenarios shift ROI outcomes? \n\n- 🚀 Capital Strategy Options: Which model (licensing, co-dev, direct sales) aligns best with financial goals? \n\n **Now, let’s incorporate your financial projections, go-to-market scaling plans, and risk mitigation strategies**",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Go ahead",
      assistant_message:
        " To complete the financial foundation of your report, please share details in the following areas:\n\n  📊 Financial Projections:\n\n- Revenue goals \n\n- Margin assumptions \n\n - Modeling techniques used \n\n 🚀 Scaling Plan:\n\n- Target markets or segments \n\n- Sales channels or KOL strategies \n\n - Performance milestones \n\n ⚠️ Risks & Mitigation \n\n- Financial, operational, and regulatory threats \n\n- Planned mitigation actions",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `📊Financial Projections:\n\n -$16M cumulative revenue over 3 years\n- 4,000 units at $4,000 each\n\n-Gross margins ~70%; breakeven by Year 3 \n\n -DCF modeling + scenario analysis (low/mid/high adoption) \n\n 🚀 Scaling Plan:\n\n- U.S. neurosurgical center rollout → EU expansion post-CE mark \n\n- Partner with KOLs, surgical distributors \n\n - Reinvest early profits into manufacturing and regulatory scaling \n\n - Metrics: hospital integrations, units/quarter, reimbursement milestones \n\n ⚠️ Risks & Mitigation \n\n- FDA delays → parallel pre-submission strategy \n\n- Adoption gaps → flexible pricing + clinician education \n\n-Manufacturing delays → dual-vendor agreements \n\n Supply volatility → lock-in long-lead materials 6 months early`,
      assistant_message:
        " Thank you! Here's the full summary of your inputs:\n\n  📊 Financial Projections:\n\n- $16M revenue; 70% gross margin \n\n- DCF + multi-scenario ROI modeling \n\n - Influencers: FDA timing, hospital procurement, reimbursement status \n\n 🚀 Scaling Plan:\n\n- U.S. neurosurgical centers → EU expansion \n\n- Channel: KOLs + surgical product distributors \n\n - Metrics: Integrations, quarterly units, procedural codes \n\n ⚠️ Risks & Mitigation \n\n- **Regulatory:** Parallel tracks \n\n- **Adoption:** Education + pricing pilots \n\n- **Ops:** Dual vendors + inventory strategy \n\n\n- **Shall we move on?**",
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `Yes`,
      assistant_message:
        " Thanks for all your input! Your Financial Viability & Commercialization Strategy Report for ParenchyGel will include:\n\n  📌 Executive Summary \n\n- 📈 Pricing Validation & Breakeven Modeling \n\n- 📊 ROI Forecast Across Adoption Scenarios \n\n - 🧮 Sensitivity Analysis (COGS vs. Adoption Rate)\n\n 🚀 Capital Strategy Benchmark: License vs. Co-Dev vs. Direct Sales \n\n 🏁 Scaling Roadmap & Revenue Milestones \n\n ⚠️ Risk Matrix & Mitigation Framework \n\n💸 Investor-Ready Commercialization Scorecard  \n\n You’ll be notified once the report is ready to view. \n\n Let me know if you'd like to adjust the structure or focus on additional investor-specific insights! ",
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
  ],
};

export const fundRaisingAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hello and welcome! 👋 I’m your Fundraising Strategy Agent. I’ll help you prepare for strategic investment or acquisition by identifying exit comps, investor profiles, and positioning tactics.

\nTo begin, could you please specify your key fundraising goals? For example:

- Identify relevant investors for your sector and stage
- Benchmark valuation and exit multiples
- Refine your deck and messaging for strategic funding or M&A

What are your main objectives?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        "We want to map exit and M&A strategies for Narratize AI, a generative AI company serving enterprise R&D and innovation teams. The goal is to benchmark comparable exits (e.g., Jasper AI, CTRL-Labs, Granulate, Hugging Face), identify strategic acquirers, and frame the company's strengths to prepare for a high-valuation acquisition or growth-stage investment.",
      assistant_message: "",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 2,
      user_message: "",
      assistant_message: `Thank you! Here's a summary of your objectives:\n\n
- Map potential exits and M&A strategies for Narratize AI
- Benchmark valuation multiples from comparable deals
- Identify strategic acquirers in enterprise-focused AI
- Position Narratize for a strong exit or high-growth fundraising round\n
Shall we move to the next step?
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:09:12.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 2,
      user_message: "Yes",
      assistant_message: `Please upload any supporting documents that can help us build your fundraising strategy. These may include:\n
- Pitch decks or investor-facing presentations
- Financial statements or revenue projections
- Previous funding details and cap table
- Market maps or competitor benchmarks \n
Once uploaded, I’ll review the materials and summarize the key insights for your confirmation before proceeding.
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:09:12.540176",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[["","Thanks! I’ve reviewed your uploaded document. Here’s a summary of the key details extracted:"],

["Company:", "Narratize AI"],

["Industry:","Generative AI for enterprise knowledge workflows"],

["Product:","Structured content generation for R&D, life sciences, and innovation workflow"],

["Technology/IP:",
"• Proprietary LLMs + ontologies\\n• Submission-ready, patent-grade outputs\\n• AI-powered narrative engine + knowledge graph"],

["Business Model:","SaaS (ARR-driven), with enterprise contracts"],

["Funding to Date:", "~$2M raised from Kubera and HearstLab"],

["Key Metrics:", "YoY growth, customer traction, IP defensibility, strong partner ecosystem"],

["Market Size:","$803B by 2033 (CAGR: 46.5%)"],

["Exit Comparables:","Jasper AI ($1.5B), CTRL-Labs (Meta), Granulate (Intel), Hugging Face"],

["Potential Acquirers:","Microsoft, Salesforce, Palantir, ServiceNow, Databricks"],

["Positioning:","Enterprise AI workflow orchestration + strategic IP moat"],
["Does this look accurate to you?",
"Let me know if you’d like to revise or add anything. If it looks good, we’ll move on to your short- and long-term fundraising goals."]]}`,
      assistant_message: "@@Edit Summary@@\n- @@Looks Good@@",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Narratize_AI_FundraisingOverview.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Looks Good",
      assistant_message: `Please share your short- and long-term goals for this fundraising effort. Also, let us know your criteria for targeting investors:

- Preferred investor type (VC, strategic, corporate
- Funding round type (e.g., Seed, Series A/B)
- Geographic or sectoral focus`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `Short-Term: Prepare materials and positioning for outreach to growth-stage investors and strategic acquirers in the enterprise AI space.
\nLong-Term: Achieve a high-multiple exit or strategic Series A by aligning our IP, product strength, and market adoption with investor and acquirer priorities.`,
      assistant_message: `Got it. Summary:
- **Short-Term**: Outreach prep for investor/acquirer engagement
- **Long-Term**: Positioning for a high-multiple exit or milestone Series A

Next, let’s confirm the key questions your report should answer.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Let’s move to the next step",
      assistant_message: `Please list the key questions you want this fundraising report to answer. These may include:

- Exit comparables and their multiples
- Acquirer motivations
- Strategic investor targeting
- Readiness metrics and valuation drivers`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `Let’s answer:

1. What are the top exit comparables in generative AI, and what were their multiples?
2. What strategic buyers are most active in AI workflow platforms or innovation enablement?
3. How can Narratize position its IP, traction, and use case to command a strong multiple?
4. What financial, product, and messaging readiness is needed to engage strategic investors or acquirers?`,
      assistant_message: `Thank you! These are your key strategic questions:

1. Exit benchmarks and valuation multiples from similar AI firms
2. Most active acquirers and their strategic logic
3. Optimal positioning of Narratize’s strengths for funding or M&A
4. Fundraising and acquisition readiness — across financials, product, and storytelling

Now let’s finalize the final prep step.`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Go ahead",
      assistant_message: `Based on your goals and questions, here are example search directions we’ll explore while building your report 
      \n Feel free to suggest any additional themes or specific comps you'd like us to include. @@Submit@@`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
  ],
};

export const legalCompliamceAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hello! 👋 I’m your **Legal & Compliance Agent**, here to guide you through a thorough **legal readiness and IP risk analysis** for your product.
\nLet’s start with your main goals for this engagement. For example:

- Assess compliance with industry-specific regulations
- Benchmark your IP portfolio against competitors
- Evaluate licensing opportunities and infringement risks

**What would you like this report to focus on?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: `We want to assess whether our patented spherical VTOL UAV can be legally commercialized without infringing on third-party IP — and define a strategic legal roadmap for compliance, licensing, and long-term market entry.`,
      assistant_message: `Thank you! Here's a quick summary of your objectives:
- ⚖️ Assess freedom-to-operate (FTO) and third-party IP infringement risks for the spherical VTOL UAV
- 🧭 Define a legal roadmap for compliance, licensing, and future market entry
**Does that sound accurate?** If so, we’ll move on.
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 2,
      user_message: "Yes",
      assistant_message: `Excellent. Please upload any documents that can support this analysis. These could include:\n\n
- 📄 Patent filings, FTO reports, or IP summaries
- 📊 Regulatory audit results or compliance checklists
- 📜 Licensing contracts or strategic legal memos
Once uploaded, I’ll review and extract the key insights to confirm with you.
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:09:12.540176",
    },

    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[["","Thanks! I’ve reviewed the uploaded FTO report. It includes:"],

["","• Patent risk landscape and IP mapping\\n• Strategic licensing recommendation\\n• Potential infringement concerns tied to propulsion, flight control, and hybrid design elements"],
["Is there anything else you’d like to upload before we continue?",""]]}`,
      assistant_message: "@@Edit Summary@@\n- @@No, that’s it@@",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Oklahoma Tech Hub_Freedom-To-Operate (FTO) Report.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "No, that’s it",
      assistant_message: `Let’s capture your legal strategy across both immediate and future horizons. What are your:

- **Short-Term Goals**? (e.g., build legal risk map, initiate licensing talks)
- **Long-Term Goals**? (e.g., repeatable compliance model, future IP monitoring)

Also, are there specific regulations (FAA, FCC, ITAR, etc.) or standards relevant to your operations?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `Short-Term: Build a legal roadmap to avoid IP infringement, including a cost-benefit analysis for licensing, redesign, or invalidation.\n
Long-Term: Enable sustainable commercialization of our VTOL platform with a repeatable compliance framework, strategic partnerships, and proactive IP monitoring.`,
      assistant_message: `Got it.
- **🎯Short-Term**: Avoid infringement and evaluate mitigation strategies (license, redesign, invalidate)
- **📈Long-Term**: Build compliance infrastructure, maintain IP defensibility, and form strategic legal alliances

**Shall we move on?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Yes",
      assistant_message: `Let’s define the key legal and IP questions this report should answer. Consider:

- Patent risks and overlaps
- Licensing vs. redesign tradeoffs
- Estimated legal timelines and costs
- Strategies for dealing with dominant IP holders (e.g., Boeing, DJI)
- Regulatory alignment or environmental risks

**Please list 3–6 core questions you'd like answered.**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `1. Which existing patents pose the highest legal risk to our VTOL commercialization strategy, and why?
2. For each high- and moderate-risk patent, what’s the most feasible and cost-effective strategy: licensing, redesign, or invalidation?
3. What are the estimated legal costs, timelines, and ROI for each mitigation pathway?
4. Which patented features overlap most with our own — and what specific changes would reduce risk?
5. What’s the best way to structure licensing negotiations with Boeing, DJI, and Lockheed Martin?
6. How can we future-proof our legal strategy for next-gen enhancements like AI, sensors, or autonomy?`,
      assistant_message: `Excellent. Here’s the summary of your core legal inquiries:

- 📌 **Patent Risk Mapping:** High-risk overlaps and infringement vulnerabilities
- 🔁 **Mitigation Options:** Tradeoffs across licensing, redesign, or legal challenges
- 💰 **Cost & ROI Forecast:** Legal timelines, expenses, and expected return per path
- ⚙️ **Feature Conflict Analysis:** Where your design most overlaps and how to reduce exposure
- 🤝 **Licensing Strategy:** Negotiation best practices with large patent holders
- 🔮 **Future-Proofing:** Legal planning for autonomous and AI-driven enhancements

**Any concerns around safety, environmental compliance, or regulatory standards?**`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "No additional concerns. Please proceed.",
      assistant_message: `Thanks for all the details! Here’s what your Legal & Compliance Report will include: \n
- 📌 Executive Summary
- 🧭 Freedom-to-Operate (FTO) Risk Assessment
- 📜 Patent Overlap & Infringement Matrix
- 💰 Cost-Benefit Comparison: License vs. Redesign vs. Invalidation
- ⚖️ IP Strategy Recommendations & Licensing Playbook
- 🚀 Legal Roadmap for Future Enhancements (AI, Autonomy)
- 🛡️ Regulatory Alignment & Long-Term Compliance Plan
      \n You’ll be notified as soon as your full report is generated and ready to review. Let me know if you'd like to customize any sections before finalization! @@Submit@@`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
  ],
};

export const portfolioSupportAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hi there! 👋 I’m your **Portfolio Support Agent**, here to help you assess portfolio performance and identify actionable opportunities to **improve ROI and reduce risk**.
\nLet’s start with your primary objective. For example:

- Track growth metrics for a specific portfolio company
- Identify scaling opportunities in a specific sector
- Evaluate revenue trends across your venture portfolio

**What would you like to focus on?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: `We want to evaluate the health of Union Square Ventures’ portfolio by identifying high-performing and underperforming companies, understanding their valuation and financial performance, and receiving strategic recommendations for reallocation, divestment, or additional support.`,
      assistant_message: `Thank you! Here's a quick summary of your objectives:
- Evaluate portfolio health for Union Square Ventures
- Identify top- and bottom-performing companies
- Assess financial performance and valuation drivers
- Generate strategic recommendations for reallocation, divestment, and support\n
**Shall we proceed?**.
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 2,
      user_message: "Yes",
      assistant_message: `Perfect! Please upload any documents that contain relevant performance data. These may include:\n\n
- 📄 Financial reports (revenue, profit/loss statements)
- 📈 Operational benchmarks
- 📁 Scaling plans or market expansion roadmaps\n
Once you upload, I’ll review the contents and extract key insights..
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:09:12.540176",
    },

    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[["","Thanks! I’ve reviewed the document and here’s a quick summary of the key takeaways:"],

["High-Performers:"," Coinbase, Duolingo, Twilio, Pendo, Dataiku, Clickhouse, Bluecore, Dashlane\\n→ Strong growth in valuation, market presence, ROI, and revenue"],

["Underperformers:","Helium, Kickstarter, Codecademy, Skillshare \\n→ Issues with valuation decline, cash flow, negative ROI"],

["Strategic Insight:"," Reallocation of capital from underperformers to top performers recommended"],
["Shall we move forward?",""]]}`,
      assistant_message: "@@Edit Summary@@\n- @@Yes@@",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Union Square Ventures – Portfolio Health.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Yes",
      assistant_message: `Let’s map out your short- and long-term priorities. This will help shape both strategic and operational layers of the report. Please share:

- **Short-Term Goals?** (e.g., divestment options, rescue plans, urgent reallocations)
- **Long-Term Goals?** (e.g., increasing ROI, systemic reduction in failure rate)`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `Short-Term: 
• Identify companies like Helium, Codecademy, Kickstarter that are dragging down performance
• Recommend urgent corrective actions (divest, pivot, pause, support)

Long-Term: 
• Maximize returns from stars like Duolingo, Coinbase, and Twilio
• Reallocate capital from underperformers to stars
• Reduce failure rate from ~90% to under 30% through a support framework`,
      assistant_message: `Got it.
- **🎯Short-Term:** Risk mitigation for weak performers + urgent tactical recommendations
- **📈Long-Term:** Return maximization, systemic resource reallocation, failure-rate reduction

**Shall we define your key questions next?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Yes",
      assistant_message: `Let’s now outline the top questions you’d like this report to answer. These might include:

- Which companies are at highest risk?
- What metrics separate top and bottom performers?
- Where should we double down or exit?

**Please share 4–6 key questions.**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `1. Which companies in our portfolio are at highest financial or market risk and should be considered for divestment?
2. What are the key indicators that distinguish our best-performing companies (e.g., Duolingo, Coinbase, Twilio)?
3. How can we best reallocate resources — which “stars” should receive additional support or capital?
4. Are there patterns (e.g., sector, burn rate, valuation change) that correlate with underperformance across the portfolio?
5. What concrete actions (e.g., fundraising support, operational efficiency programs, M&A) can reduce our failure rate from 90% to 30%?
6. How can we structure proactive quarterly monitoring to flag issues early and avoid write-offs?`,
      assistant_message: `Thank you! Here’s the recap of your strategic questions:

- 🚩 Risk Analysis: Identify divestment candidates based on financial/market exposure
- 🌟 Success Signals: Unpack key traits of top performers
- 🔁 Capital Reallocation: Strategic bets on scalable winners
- 📉 Pattern Detection: Detect trends linked to consistent underperformance
- 🛠️ Corrective Actions: Tactical levers to reduce failure rate from 90% to 30%
- ⏱️ Early-Warning System: Define quarterly check-ins to reduce write-off risks

**Would you like to add any known challenges or operational blockers before we finalize?**`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "No, looks good. Please proceed.",
      assistant_message: `Thanks for all your inputs! Based on everything we’ve discussed, your Portfolio Health Report will include:\n
- 📌 **Executive Summary**
- 📉 **Risk Profiling:** Underperformers & Divestment Candidates
- 📈 **Top Performer Deep Dive:** Traits & Indicators
- 🔁 **Capital Allocation Framework:** High-ROI Opportunities
- 📊 **Pattern & Trend Analysis:** Sector, Burn Rate, Valuation Change
- ⚙️ **Intervention Toolkit:** Divestment, M&A, Operational Support
- ⏰ **Quarterly Monitoring System & Early-Warning Metrics**
      \n You’ll be notified as soon as the report is ready for review. Let me know if you want to customize or prioritize any specific sections before we wrap! @@Submit@@`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
  ],
};

export const reportAnythingAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Hello! 👋 I’m your **Report on Anything Agent**, ready to help you generate a **full commercialization report** from outline to insights.
Let’s start with your primary goal. For example:

- Analyze emerging trends in AI-powered diagnostics
- Evaluate market readiness and user demand
- Map commercialization pathways and regulatory roadblocks

**What would you like this report to focus on?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: `We want to generate a full commercialization report using this outline for our startup. The product is an AI-driven nutrition diagnostics wearable.`,
      assistant_message: `Thank you! Here's a quick summary of your goal:
- Generate a full commercialization report for your AI-driven nutrition diagnostics wearable startup
- Use the uploaded outline as the report framework\n
**Is that correct? If so, we’ll move to document intake.**.
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6069,
      user_id: "272",
      thread_id: "1530",
      step: 2,
      user_message: "Yes, move on",
      assistant_message: `Great! Please upload any documents that will help us build the report. Suggested materials include:\n\n
- 📄 Market research or clinical studies
- 📊 Financial projections or performance dashboards
- 📁 Regulatory assessments or technical memos\n
Once uploaded, I’ll review and confirm next steps.
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:09:12.540176",
    },

    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[["","Thanks! I’ve reviewed your outline, and here’s what it includes:"],

["📄 Outline Sections Identified:",

"\\n• Market Analysis\\n• Financial Performance\\n• Customer Segmentation\\n• TAM/SAM/SOM Estimates\\n• Competitor Landscape\\n• Regulatory Environment\\n• Commercialization Score\\n• Technical Feasibility\\n• Financial Viability\\n• Team & Execution Strategy"],["Looks like a great foundation. Let’s continue.",""]]}`,
      assistant_message: "@@Edit Summary@@\n- @@Yes, go ahead@@",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Market Report Outline.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Yes, go ahead",
      assistant_message: `To tailor the report’s tone and scope, let’s define your goals:

- **Short-Term Goals**? (e.g., investor-readiness, pre-launch strategy)
- **Long-Term Goals**? (e.g., regulatory alignment, launch-phase playbooks)\n

**Could you share your key goals?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `Short-Term: Prepare a polished commercialization readiness report for pre-seed investor conversations.

Long-Term: Use this framework to update quarterly reports as the business grows (R&D → FDA → market launch).`,
      assistant_message: `Perfect. Summary of your goals:
- **🗓️Short-Term:** Investor-facing report for commercialization readiness
- **🗓Long-Term:** Living report structure to support growth from R&D to launch

**Shall we continue with defining the critical questions?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Yes",
      assistant_message: `Let’s outline the key strategic questions this report should answer. These will help shape the insights we deliver. Here are some examples:

- What’s the current market size for AI nutrition tools?
- What are user needs and regulatory barriers?
- What is our commercialization potential?

**What are your top 3–5 questions?**`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: `1. What is our commercialization score across technical, regulatory, and financial axes?
2. How should we refine our GTM plan to match market dynamics?
3. What are the major regulatory bottlenecks and how can we mitigate them?`,
      assistant_message: `Got it! Here’s the recap of your Burning Questions:

- 📊 Readiness Metrics: Commercialization score across tech, regulation, and finance
- 🚀 Go-to-Market Refinement: How to tailor GTM plan for the current market
- ⚖️ Regulatory Hurdles: Bottlenecks and mitigation strategies

**Would you like to showcase any data sources or request additional research directions before we proceed to final prep?**`,
      json_datasources: dataSources,
      json_report: {},
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
    {
      id: 6106,
      user_id: "272",
      thread_id: "1538",
      step: 3,
      user_message: "Let’s move on.",
      assistant_message: `Thanks for your input! Your Commercialization Readiness Report will include:\n
- 📌 **Executive Summary**
- 📈 **Market Opportunity:** TAM/SAM/SOM & User Demand
- 🚀 **Go-to-Market Plan & Refinement Strategies**
- ⚖️ **Regulatory Roadmap & Bottleneck Mitigation**
- 🧪 **Commercialization Scorecard:** Technical, Regulatory, Financial
- 👤 **Customer Segmentation & Needs Mapping**
- 📊 **Financial Viability & Risk Assessment**
- 🏁 **Execution Strategy & Team Readiness**
      \n You’ll be notified as soon as the report is complete and ready to review. Let me know if you’d like to revise the structure or highlight specific markets, competitors, or technologies. @@Submit@@`,
      json_datasources: {},
      json_report: reportTemplates,
      filename_url: {},
      created_at: "2025-05-06T08:20:44.585865",
    },
  ],
};

export const priorArtAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `What would you like to call this invention? A product name, project code, or even your team’s nickname for it works.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "SmartSeal – Modular Sensor-Enabled Packaging System",
      assistant_message: `What’s the core problem this invention addresses? And who’s the end user or customer benefiting from it?
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        "It addresses inefficiencies in packaging freshness and logistics. It's meant for supply chain managers and manufacturers looking to track product integrity.",
      assistant_message: `Walk me through the big picture: what goes in, what happens inside, and what comes out?
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        "It’s a modular sealing system embedded with environmental sensors. The data gets relayed via low-power connectivity to a dashboard. The design enables reuse and supports compliance logging.",
      assistant_message: `What parts of your solution do you believe are technically novel or cleverly engineered?
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: `
- Reusable sensor-enabled closure
- Integrated low-power transmission
- Tool-free modular cartridge
- Compatibility with a wide range of container types
        `,
      assistant_message: `Have you seen anything out there that tackles this problem in a similar way? Any systems, mechanisms, or concepts worth noting?
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: `
There are basic sensor caps and a few track-and-trace platforms, but none combine modularity, real-time sensing, and plug-and-play deployment in industrial settings.
        `,
      assistant_message: `Which countries or regions do you want to prioritize for IP protection or commercial rollout?
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: `
      United States, Europe, Japan, and South Korea
        `,
      assistant_message: `Attach any technical documents that can help clarify the design — CADs, architecture slides, early drafts, even hand sketches. 
      `,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[]}`,
      assistant_message: "",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Oncology_TumorBoard_WorkflowInsights.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[]}`,
      assistant_message:
        "Based on what you've described, here are some starting terms for the prior art search. You can add your own or tweak as needed.",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "ConnectivityStack_Overview.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
         "json_response": sampleKeywords,
    },
     {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `Continue`,
      assistant_message:

      "Almost there! The final stencil of your report is ready in the right pane. Review, add or modify sections as needed before final submission.",
      json_datasources: {},
      json_report: {
        "sections": {
            "0": {
                "title": "Invention Disclosure Analysis",
                "summary": "Overview of the disclosed invention and its core components.",
                "body": "",
                "subsections": {
                    "0.1": {
                        "title": "Invention Title",
                        "summary": "The name of the invention.",
                        "body": "SmartSeal – Modular Sensor-Enabled Packaging System"
                    },
                    "0.2": {
                        "title": "Core Problem and Target Audience",
                        "summary": "Problems addressed and intended users of the invention.",
                        "body": "The core problem addressed by SmartSeal is inefficiencies in packaging freshness and logistics. The target audience includes supply chain managers and manufacturers looking to track product integrity."
                    },
                    "0.3": {
                        "title": "High-Level System Workflow",
                        "summary": "Overview of how the system works.",
                        "body": "Input: Reusable sensor-enabled closure. Transformation: Monitors environmental conditions (e.g., temperature, humidity), tracks data related to product integrity. Output: Sends alerts if conditions deviate from optimal, generates reports on product freshness and logistics."
                    },
                    "0.4": {
                        "title": "Technical Novelty Details",
                        "summary": "Unique aspects of the invention.",
                        "body": "The SmartSeal features a reusable closure integrated with sensors. It combines modularity, real-time sensing, and plug-and-play deployment. Unlike basic sensor caps and track-and-trace platforms, SmartSeal integrates all these features for use in industrial settings."
                    },
                    "0.5": {
                        "title": "Known Similar Solutions",
                        "summary": "Existing solutions and their comparison.",
                        "body": "Overlaps: Basic sensor caps exist and there are a few track-and-trace platforms. Differences and Advantages: SmartSeal combines modularity, real-time sensing, and plug-and-play deployment, specifically designed for industrial settings, which is not typically addressed by existing solutions."
                    },
                    "0.6": {
                        "title": "Commercialization & IP Strategy",
                        "summary": "Regions targeted for commercialization and protection strategy.",
                        "body": "Countries/Regions for Commercialization and Protection: United States, Europe, Japan, South Korea. Protection Strategy: Focus on regional rollouts in the specified areas."
                    }
                }
            },
            "1": {
                "title": "Report Objective",
                "summary": "Goal of the report.",
                "body": "This report aims to analyze the SmartSeal invention in detail, evaluating its novelty, potential overlaps with existing solutions, and strategies for commercialization and IP protection.",
                "subsections": {}
            },
            "2": {
                "title": "Search Methodology",
                "summary": "Method used for the search.",
                "body": "A thorough search was conducted using relevant databases and keywords to identify existing solutions and literature related to sensor-enabled packaging systems.",
                "subsections": {
                    "2.1": {
                        "title": "Keywords Used",
                        "summary": "Keywords applied during the search process.",
                        "body": "Keywords used during the search process included sensor-enabled closure, real-time monitoring, data tracking, modularity, industrial settings, Arduino, reusable packaging, and plug-and-play deployment."
                    }
                }
            },
            "3": {
                "title": "Prior Art Search Analysis",
                "summary": "Analysis of prior art.",
                "body": "The analysis involved comparing SmartSeal to existing solutions, focusing on its unique features and potential overlaps.",
                "subsections": {
                    "3.1": {
                        "title": "Summary Table",
                        "summary": "Table summarizing the prior art search.",
                        "body": "A table was created to summarize the findings of the prior art search, highlighting key differences and similarities with existing solutions."
                    },
                    "3.2": {
                        "title": "Claims Comparison Chart",
                        "summary": "Comparison of the claims.",
                        "body": "A chart was used to compare the claims of SmartSeal against other similar inventions, showing the unique aspects and potential overlaps."
                    }
                }
            },
            "4": {
                "title": "Citation Analysis",
                "summary": "Analysis of citations.",
                "body": "An analysis of backward and forward citations was conducted to understand the impact and relevance of the SmartSeal invention.",
                "subsections": {
                    "4.1": {
                        "title": "Backward Citations",
                        "summary": "Review of prior patents cited by SmartSeal.",
                        "body": "Backward citations include key patents and literature that have influenced the development of SmartSeal."
                    },
                    "4.2": {
                        "title": "Forward Citations",
                        "summary": "Analysis of subsequent patents citing SmartSeal.",
                        "body": "Forward citations include patents and publications that have referenced SmartSeal, indicating its influence on subsequent innovations."
                    },
                    "4.3": {
                        "title": "Citation Network Visualization",
                        "summary": "Visual representation of citation relationships.",
                        "body": "A visual network was created to illustrate the relationships between SmartSeal and other patents through citations."
                    },
                    "4.4": {
                        "title": "Observations",
                        "summary": "Key takeaways from the citation analysis.",
                        "body": "The citation analysis reveals SmartSeal's strong influence on subsequent innovations and its reliance on prior foundational patents."
                    }
                }
            },
            "5": {
                "title": "Optional Add-Ons",
                "summary": "Additional analysis and insights.",
                "body": "Further analysis and insights that may provide additional value.",
                "subsections": {
                    "5.1": {
                        "title": "Visual Comparison Table",
                        "summary": "Visual table comparing SmartSeal to existing solutions.",
                        "body": "A visual comparison table was created to highlight the unique features and advantages of SmartSeal compared to existing solutions."
                    },
                    "5.2": {
                        "title": "Market Landscape Mapping",
                        "summary": "Analysis of the market landscape.",
                        "body": "The market landscape analysis maps out the competitive environment and identifies key players and potential opportunities for SmartSeal."
                    }
                }
            },
            "6": {
                "title": "Strategic Recommendations",
                "summary": "Suggestions for future actions.",
                "body": "Recommendations for leveraging SmartSeal's unique features and pursuing strategic opportunities.",
                "subsections": {
                    "6.1": {
                        "title": "Technical Differentiation",
                        "summary": "Recommendations for maintaining innovation.",
                        "body": "Focus on continuous improvement of sensory capabilities and modular design to stay ahead of competitors."
                    },
                    "6.2": {
                        "title": "Suggested Filing Strategy",
                        "summary": "Recommendations for filing patents.",
                        "body": "Adopt a phased filing strategy starting with the core regions of the United States, Europe, Japan, and South Korea, and expand based on market feedback."
                    },
                    "6.3": {
                        "title": "Final Patentability Snapshot",
                        "summary": "Snapshot of the patentability assessment.",
                        "body": "| Element | Novelty | Prior Art Risk | Strategic Value | Filing Recommendation |\n|---|---|---|---|---|\n| SmartSeal | High | Low | High | Strongly Recommended |"
                    }
                }
            }
        }
    },
      filename_url: {
        "ConnectivityStack_Overview.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
  ],
};

export const ftoAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Let’s start with the name of the invention or product — what do you call it internally or plan to call it in the market?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "MagBeauty Buddy – Refillable Compact",
      assistant_message: `Which features are critical to your design or value prop — the kind that would be hard to remove or replace?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:
        "Refill cartridge, magnetic lid, spring-ejection system, recyclable materials, and possible mobile app integration.",
      assistant_message:`To make sure we’re clearing the right markets — where will this be launched, produced, or distributed?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:"Launch in the U.S. and Europe, manufacture in Korea or China, and possibly expand into Japan and Australia later",
      assistant_message: `Have you come across any companies that might have relevant IP in this space — packaging, smart cosmetics, or otherwise?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "I’ve seen refillable packaging from some global cosmetic brands, and a few newer players experimenting with NFC-enabled cases.",
      assistant_message: `If we flag risks — would you rather license, redesign, or steer clear entirely? Helps us know what to recommend.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "Yes, minor design adjustments are fine. I’d prefer to avoid licensing unless absolutely necessary.",
      assistant_message: "Sketches, CADs, feature maps, or early spec sheets — anything that helps us understand the build and layout.",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
   
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[]}`,
      assistant_message: "",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Refillable_Cartridge_CAD.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[]}`,
      assistant_message:"Based on what you've shared, these are the functional keywords I’ll use to search for enforceable claims. Add to them if needed.",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Packaging_Design_Features.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
         "json_response": sampleKeywords,
    },
     {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `Continue`,
      assistant_message:

      "Almost there! The final stencil of your report is ready in the right pane. Review, add or modify sections as needed before final submission.",
      json_datasources: {},
      json_report: {
        "sections": {
            "0": {
                "title": "Invention Disclosure Analysis",
                "summary": "Overview of the disclosed invention and its core components.",
                "body": "",
                "subsections": {
                    "0.1": {
                        "title": "Invention Title",
                        "summary": "The name of the invention.",
                        "body": "SmartSeal – Modular Sensor-Enabled Packaging System"
                    },
                    "0.2": {
                        "title": "Core Problem and Target Audience",
                        "summary": "Problems addressed and intended users of the invention.",
                        "body": "The core problem addressed by SmartSeal is inefficiencies in packaging freshness and logistics. The target audience includes supply chain managers and manufacturers looking to track product integrity."
                    },
                    "0.3": {
                        "title": "High-Level System Workflow",
                        "summary": "Overview of how the system works.",
                        "body": "Input: Reusable sensor-enabled closure. Transformation: Monitors environmental conditions (e.g., temperature, humidity), tracks data related to product integrity. Output: Sends alerts if conditions deviate from optimal, generates reports on product freshness and logistics."
                    },
                    "0.4": {
                        "title": "Technical Novelty Details",
                        "summary": "Unique aspects of the invention.",
                        "body": "The SmartSeal features a reusable closure integrated with sensors. It combines modularity, real-time sensing, and plug-and-play deployment. Unlike basic sensor caps and track-and-trace platforms, SmartSeal integrates all these features for use in industrial settings."
                    },
                    "0.5": {
                        "title": "Known Similar Solutions",
                        "summary": "Existing solutions and their comparison.",
                        "body": "Overlaps: Basic sensor caps exist and there are a few track-and-trace platforms. Differences and Advantages: SmartSeal combines modularity, real-time sensing, and plug-and-play deployment, specifically designed for industrial settings, which is not typically addressed by existing solutions."
                    },
                    "0.6": {
                        "title": "Commercialization & IP Strategy",
                        "summary": "Regions targeted for commercialization and protection strategy.",
                        "body": "Countries/Regions for Commercialization and Protection: United States, Europe, Japan, South Korea. Protection Strategy: Focus on regional rollouts in the specified areas."
                    }
                }
            },
            "1": {
                "title": "Report Objective",
                "summary": "Goal of the report.",
                "body": "This report aims to analyze the SmartSeal invention in detail, evaluating its novelty, potential overlaps with existing solutions, and strategies for commercialization and IP protection.",
                "subsections": {}
            },
            "2": {
                "title": "Search Methodology",
                "summary": "Method used for the search.",
                "body": "A thorough search was conducted using relevant databases and keywords to identify existing solutions and literature related to sensor-enabled packaging systems.",
                "subsections": {
                    "2.1": {
                        "title": "Keywords Used",
                        "summary": "Keywords applied during the search process.",
                        "body": "Keywords used during the search process included sensor-enabled closure, real-time monitoring, data tracking, modularity, industrial settings, Arduino, reusable packaging, and plug-and-play deployment."
                    }
                }
            },
            "3": {
                "title": "Prior Art Search Analysis",
                "summary": "Analysis of prior art.",
                "body": "The analysis involved comparing SmartSeal to existing solutions, focusing on its unique features and potential overlaps.",
                "subsections": {
                    "3.1": {
                        "title": "Summary Table",
                        "summary": "Table summarizing the prior art search.",
                        "body": "A table was created to summarize the findings of the prior art search, highlighting key differences and similarities with existing solutions."
                    },
                    "3.2": {
                        "title": "Claims Comparison Chart",
                        "summary": "Comparison of the claims.",
                        "body": "A chart was used to compare the claims of SmartSeal against other similar inventions, showing the unique aspects and potential overlaps."
                    }
                }
            },
            "4": {
                "title": "Citation Analysis",
                "summary": "Analysis of citations.",
                "body": "An analysis of backward and forward citations was conducted to understand the impact and relevance of the SmartSeal invention.",
                "subsections": {
                    "4.1": {
                        "title": "Backward Citations",
                        "summary": "Review of prior patents cited by SmartSeal.",
                        "body": "Backward citations include key patents and literature that have influenced the development of SmartSeal."
                    },
                    "4.2": {
                        "title": "Forward Citations",
                        "summary": "Analysis of subsequent patents citing SmartSeal.",
                        "body": "Forward citations include patents and publications that have referenced SmartSeal, indicating its influence on subsequent innovations."
                    },
                    "4.3": {
                        "title": "Citation Network Visualization",
                        "summary": "Visual representation of citation relationships.",
                        "body": "A visual network was created to illustrate the relationships between SmartSeal and other patents through citations."
                    },
                    "4.4": {
                        "title": "Observations",
                        "summary": "Key takeaways from the citation analysis.",
                        "body": "The citation analysis reveals SmartSeal's strong influence on subsequent innovations and its reliance on prior foundational patents."
                    }
                }
            },
            "5": {
                "title": "Optional Add-Ons",
                "summary": "Additional analysis and insights.",
                "body": "Further analysis and insights that may provide additional value.",
                "subsections": {
                    "5.1": {
                        "title": "Visual Comparison Table",
                        "summary": "Visual table comparing SmartSeal to existing solutions.",
                        "body": "A visual comparison table was created to highlight the unique features and advantages of SmartSeal compared to existing solutions."
                    },
                    "5.2": {
                        "title": "Market Landscape Mapping",
                        "summary": "Analysis of the market landscape.",
                        "body": "The market landscape analysis maps out the competitive environment and identifies key players and potential opportunities for SmartSeal."
                    }
                }
            },
            "6": {
                "title": "Strategic Recommendations",
                "summary": "Suggestions for future actions.",
                "body": "Recommendations for leveraging SmartSeal's unique features and pursuing strategic opportunities.",
                "subsections": {
                    "6.1": {
                        "title": "Technical Differentiation",
                        "summary": "Recommendations for maintaining innovation.",
                        "body": "Focus on continuous improvement of sensory capabilities and modular design to stay ahead of competitors."
                    },
                    "6.2": {
                        "title": "Suggested Filing Strategy",
                        "summary": "Recommendations for filing patents.",
                        "body": "Adopt a phased filing strategy starting with the core regions of the United States, Europe, Japan, and South Korea, and expand based on market feedback."
                    },
                    "6.3": {
                        "title": "Final Patentability Snapshot",
                        "summary": "Snapshot of the patentability assessment.",
                        "body": "| Element | Novelty | Prior Art Risk | Strategic Value | Filing Recommendation |\n|---|---|---|---|---|\n| SmartSeal | High | Low | High | Strongly Recommended |"
                    }
                }
            }
        }
    },
      filename_url: {
        "ConnectivityStack_Overview.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
  ],
};

export const patentLicensingAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message:  `Let’s start with the core of what you’ve built. What’s the invention, product, or patented technology you’re looking to license out?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "SmartSeal — a sensor-enabled packaging closure system for freshness tracking and reuse.",
      assistant_message:`What’s the big selling point? What problem does it solve in the real world — and why would someone want to pay to use it?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:"It allows real-time freshness tracking in reusable packaging formats, which is critical for cold-chain logistics and food safety. It reduces waste and improves traceability.",
      assistant_message:`Which parts of your IP are the crown jewels — the things that offer technical differentiation or clear business value?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:"The modular sensor housing, the wireless transmission system, and the reusable/recyclable cartridge interface.",
      assistant_message: `Any target industries or types of companies you have in mind? We can prioritize by use case, geography, or product category.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "Packaging manufacturers, logistics providers, and food safety platforms — especially those operating in regulated supply chains.",
      assistant_message:`Are you open to exclusive deals, or prefer to license non-exclusively? Any territories, fields of use, or applications you want to hold back?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "Non-exclusive, with royalties. We want to reserve the consumer-facing use cases and only license industrial and commercial packaging use.",
      assistant_message:"Patent documents, product decks, diagrams — anything that helps clarify what’s available for licensing.",
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
   
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[]}`,
      assistant_message: "",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "SmartSeal_Patent_Claims.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[]}`,
      assistant_message:
      "Based on what you've shared, these are the functional keywords I’ll use to search for enforceable claims. Add to them if needed.",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Tech_Overview_LicensingDeck.pptx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
         "json_response": sampleKeywords,
    },
     {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `Continue`,
      assistant_message:

      "Almost there! The final stencil of your report is ready in the right pane. Review, add or modify sections as needed before final submission.",
      json_datasources: {},
      json_report: {
        "sections": {
            "0": {
                "title": "Invention Disclosure Analysis",
                "summary": "Overview of the disclosed invention and its core components.",
                "body": "",
                "subsections": {
                    "0.1": {
                        "title": "Invention Title",
                        "summary": "The name of the invention.",
                        "body": "SmartSeal – Modular Sensor-Enabled Packaging System"
                    },
                    "0.2": {
                        "title": "Core Problem and Target Audience",
                        "summary": "Problems addressed and intended users of the invention.",
                        "body": "The core problem addressed by SmartSeal is inefficiencies in packaging freshness and logistics. The target audience includes supply chain managers and manufacturers looking to track product integrity."
                    },
                    "0.3": {
                        "title": "High-Level System Workflow",
                        "summary": "Overview of how the system works.",
                        "body": "Input: Reusable sensor-enabled closure. Transformation: Monitors environmental conditions (e.g., temperature, humidity), tracks data related to product integrity. Output: Sends alerts if conditions deviate from optimal, generates reports on product freshness and logistics."
                    },
                    "0.4": {
                        "title": "Technical Novelty Details",
                        "summary": "Unique aspects of the invention.",
                        "body": "The SmartSeal features a reusable closure integrated with sensors. It combines modularity, real-time sensing, and plug-and-play deployment. Unlike basic sensor caps and track-and-trace platforms, SmartSeal integrates all these features for use in industrial settings."
                    },
                    "0.5": {
                        "title": "Known Similar Solutions",
                        "summary": "Existing solutions and their comparison.",
                        "body": "Overlaps: Basic sensor caps exist and there are a few track-and-trace platforms. Differences and Advantages: SmartSeal combines modularity, real-time sensing, and plug-and-play deployment, specifically designed for industrial settings, which is not typically addressed by existing solutions."
                    },
                    "0.6": {
                        "title": "Commercialization & IP Strategy",
                        "summary": "Regions targeted for commercialization and protection strategy.",
                        "body": "Countries/Regions for Commercialization and Protection: United States, Europe, Japan, South Korea. Protection Strategy: Focus on regional rollouts in the specified areas."
                    }
                }
            },
            "1": {
                "title": "Report Objective",
                "summary": "Goal of the report.",
                "body": "This report aims to analyze the SmartSeal invention in detail, evaluating its novelty, potential overlaps with existing solutions, and strategies for commercialization and IP protection.",
                "subsections": {}
            },
            "2": {
                "title": "Search Methodology",
                "summary": "Method used for the search.",
                "body": "A thorough search was conducted using relevant databases and keywords to identify existing solutions and literature related to sensor-enabled packaging systems.",
                "subsections": {
                    "2.1": {
                        "title": "Keywords Used",
                        "summary": "Keywords applied during the search process.",
                        "body": "Keywords used during the search process included sensor-enabled closure, real-time monitoring, data tracking, modularity, industrial settings, Arduino, reusable packaging, and plug-and-play deployment."
                    }
                }
            },
            "3": {
                "title": "Prior Art Search Analysis",
                "summary": "Analysis of prior art.",
                "body": "The analysis involved comparing SmartSeal to existing solutions, focusing on its unique features and potential overlaps.",
                "subsections": {
                    "3.1": {
                        "title": "Summary Table",
                        "summary": "Table summarizing the prior art search.",
                        "body": "A table was created to summarize the findings of the prior art search, highlighting key differences and similarities with existing solutions."
                    },
                    "3.2": {
                        "title": "Claims Comparison Chart",
                        "summary": "Comparison of the claims.",
                        "body": "A chart was used to compare the claims of SmartSeal against other similar inventions, showing the unique aspects and potential overlaps."
                    }
                }
            },
            "4": {
                "title": "Citation Analysis",
                "summary": "Analysis of citations.",
                "body": "An analysis of backward and forward citations was conducted to understand the impact and relevance of the SmartSeal invention.",
                "subsections": {
                    "4.1": {
                        "title": "Backward Citations",
                        "summary": "Review of prior patents cited by SmartSeal.",
                        "body": "Backward citations include key patents and literature that have influenced the development of SmartSeal."
                    },
                    "4.2": {
                        "title": "Forward Citations",
                        "summary": "Analysis of subsequent patents citing SmartSeal.",
                        "body": "Forward citations include patents and publications that have referenced SmartSeal, indicating its influence on subsequent innovations."
                    },
                    "4.3": {
                        "title": "Citation Network Visualization",
                        "summary": "Visual representation of citation relationships.",
                        "body": "A visual network was created to illustrate the relationships between SmartSeal and other patents through citations."
                    },
                    "4.4": {
                        "title": "Observations",
                        "summary": "Key takeaways from the citation analysis.",
                        "body": "The citation analysis reveals SmartSeal's strong influence on subsequent innovations and its reliance on prior foundational patents."
                    }
                }
            },
            "5": {
                "title": "Optional Add-Ons",
                "summary": "Additional analysis and insights.",
                "body": "Further analysis and insights that may provide additional value.",
                "subsections": {
                    "5.1": {
                        "title": "Visual Comparison Table",
                        "summary": "Visual table comparing SmartSeal to existing solutions.",
                        "body": "A visual comparison table was created to highlight the unique features and advantages of SmartSeal compared to existing solutions."
                    },
                    "5.2": {
                        "title": "Market Landscape Mapping",
                        "summary": "Analysis of the market landscape.",
                        "body": "The market landscape analysis maps out the competitive environment and identifies key players and potential opportunities for SmartSeal."
                    }
                }
            },
            "6": {
                "title": "Strategic Recommendations",
                "summary": "Suggestions for future actions.",
                "body": "Recommendations for leveraging SmartSeal's unique features and pursuing strategic opportunities.",
                "subsections": {
                    "6.1": {
                        "title": "Technical Differentiation",
                        "summary": "Recommendations for maintaining innovation.",
                        "body": "Focus on continuous improvement of sensory capabilities and modular design to stay ahead of competitors."
                    },
                    "6.2": {
                        "title": "Suggested Filing Strategy",
                        "summary": "Recommendations for filing patents.",
                        "body": "Adopt a phased filing strategy starting with the core regions of the United States, Europe, Japan, and South Korea, and expand based on market feedback."
                    },
                    "6.3": {
                        "title": "Final Patentability Snapshot",
                        "summary": "Snapshot of the patentability assessment.",
                        "body": "| Element | Novelty | Prior Art Risk | Strategic Value | Filing Recommendation |\n|---|---|---|---|---|\n| SmartSeal | High | Low | High | Strongly Recommended |"
                    }
                }
            }
        }
    },
      filename_url: {
        "ConnectivityStack_Overview.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
  ],
};

export const patentLandscapeAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message: `Let’s set the boundaries. What’s the core tech, product category, or problem domain you’re mapping?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:"Reusable, sensor-enabled packaging systems — especially for cold-chain logistics and freshness tracking.",
      assistant_message:`Let’s narrow the lens — which components, functions, or capabilities are most relevant to your scan?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:"Modular sensor integration, smart packaging closures, NFC data sync, and recyclable or mono-material construction.",
      assistant_message:`Why now? Are you scouting the competition, spotting whitespace, or building a market entry narrative?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:"We’re identifying whitespace and tracking where the innovation clusters are, to inform a go-to-market IP strategy.",
      assistant_message:`Should we keep the scope global or focus on specific patent-heavy markets?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:`Prioritize the U.S., Europe, Korea, and Japan. Optional: China and Canada.`,
      assistant_message:  `Any players you’d like to keep on the radar — big or small?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:`Yes, packaging OEMs, smart logistics companies, and any startup that’s building smart, sustainable supply chain tech.`,
      assistant_message:`Tech briefs, product decks, or even internal wishlists help align the search to your priorities.`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
   
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[]}`,
      assistant_message: "",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "Modular_Closure_Tech_Overview.pdf":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `{"pitchdeck_summary":[]}`,
      assistant_message:"Here are the starting tags I’ll use. Feel free to build on them.",
      json_datasources: {},
      json_report: {},
      filename_url: {
        "SmartLogistics_TargetWatch.xlsx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
         "json_response": sampleKeywords,
    },
     {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `Continue`,
      assistant_message:

      "Almost there! The final stencil of your report is ready in the right pane. Review, add or modify sections as needed before final submission.",
      json_datasources: {},
      json_report: {
        "sections": {
            "0": {
                "title": "Invention Disclosure Analysis",
                "summary": "Overview of the disclosed invention and its core components.",
                "body": "",
                "subsections": {
                    "0.1": {
                        "title": "Invention Title",
                        "summary": "The name of the invention.",
                        "body": "SmartSeal – Modular Sensor-Enabled Packaging System"
                    },
                    "0.2": {
                        "title": "Core Problem and Target Audience",
                        "summary": "Problems addressed and intended users of the invention.",
                        "body": "The core problem addressed by SmartSeal is inefficiencies in packaging freshness and logistics. The target audience includes supply chain managers and manufacturers looking to track product integrity."
                    },
                    "0.3": {
                        "title": "High-Level System Workflow",
                        "summary": "Overview of how the system works.",
                        "body": "Input: Reusable sensor-enabled closure. Transformation: Monitors environmental conditions (e.g., temperature, humidity), tracks data related to product integrity. Output: Sends alerts if conditions deviate from optimal, generates reports on product freshness and logistics."
                    },
                    "0.4": {
                        "title": "Technical Novelty Details",
                        "summary": "Unique aspects of the invention.",
                        "body": "The SmartSeal features a reusable closure integrated with sensors. It combines modularity, real-time sensing, and plug-and-play deployment. Unlike basic sensor caps and track-and-trace platforms, SmartSeal integrates all these features for use in industrial settings."
                    },
                    "0.5": {
                        "title": "Known Similar Solutions",
                        "summary": "Existing solutions and their comparison.",
                        "body": "Overlaps: Basic sensor caps exist and there are a few track-and-trace platforms. Differences and Advantages: SmartSeal combines modularity, real-time sensing, and plug-and-play deployment, specifically designed for industrial settings, which is not typically addressed by existing solutions."
                    },
                    "0.6": {
                        "title": "Commercialization & IP Strategy",
                        "summary": "Regions targeted for commercialization and protection strategy.",
                        "body": "Countries/Regions for Commercialization and Protection: United States, Europe, Japan, South Korea. Protection Strategy: Focus on regional rollouts in the specified areas."
                    }
                }
            },
            "1": {
                "title": "Report Objective",
                "summary": "Goal of the report.",
                "body": "This report aims to analyze the SmartSeal invention in detail, evaluating its novelty, potential overlaps with existing solutions, and strategies for commercialization and IP protection.",
                "subsections": {}
            },
            "2": {
                "title": "Search Methodology",
                "summary": "Method used for the search.",
                "body": "A thorough search was conducted using relevant databases and keywords to identify existing solutions and literature related to sensor-enabled packaging systems.",
                "subsections": {
                    "2.1": {
                        "title": "Keywords Used",
                        "summary": "Keywords applied during the search process.",
                        "body": "Keywords used during the search process included sensor-enabled closure, real-time monitoring, data tracking, modularity, industrial settings, Arduino, reusable packaging, and plug-and-play deployment."
                    }
                }
            },
            "3": {
                "title": "Prior Art Search Analysis",
                "summary": "Analysis of prior art.",
                "body": "The analysis involved comparing SmartSeal to existing solutions, focusing on its unique features and potential overlaps.",
                "subsections": {
                    "3.1": {
                        "title": "Summary Table",
                        "summary": "Table summarizing the prior art search.",
                        "body": "A table was created to summarize the findings of the prior art search, highlighting key differences and similarities with existing solutions."
                    },
                    "3.2": {
                        "title": "Claims Comparison Chart",
                        "summary": "Comparison of the claims.",
                        "body": "A chart was used to compare the claims of SmartSeal against other similar inventions, showing the unique aspects and potential overlaps."
                    }
                }
            },
            "4": {
                "title": "Citation Analysis",
                "summary": "Analysis of citations.",
                "body": "An analysis of backward and forward citations was conducted to understand the impact and relevance of the SmartSeal invention.",
                "subsections": {
                    "4.1": {
                        "title": "Backward Citations",
                        "summary": "Review of prior patents cited by SmartSeal.",
                        "body": "Backward citations include key patents and literature that have influenced the development of SmartSeal."
                    },
                    "4.2": {
                        "title": "Forward Citations",
                        "summary": "Analysis of subsequent patents citing SmartSeal.",
                        "body": "Forward citations include patents and publications that have referenced SmartSeal, indicating its influence on subsequent innovations."
                    },
                    "4.3": {
                        "title": "Citation Network Visualization",
                        "summary": "Visual representation of citation relationships.",
                        "body": "A visual network was created to illustrate the relationships between SmartSeal and other patents through citations."
                    },
                    "4.4": {
                        "title": "Observations",
                        "summary": "Key takeaways from the citation analysis.",
                        "body": "The citation analysis reveals SmartSeal's strong influence on subsequent innovations and its reliance on prior foundational patents."
                    }
                }
            },
            "5": {
                "title": "Optional Add-Ons",
                "summary": "Additional analysis and insights.",
                "body": "Further analysis and insights that may provide additional value.",
                "subsections": {
                    "5.1": {
                        "title": "Visual Comparison Table",
                        "summary": "Visual table comparing SmartSeal to existing solutions.",
                        "body": "A visual comparison table was created to highlight the unique features and advantages of SmartSeal compared to existing solutions."
                    },
                    "5.2": {
                        "title": "Market Landscape Mapping",
                        "summary": "Analysis of the market landscape.",
                        "body": "The market landscape analysis maps out the competitive environment and identifies key players and potential opportunities for SmartSeal."
                    }
                }
            },
            "6": {
                "title": "Strategic Recommendations",
                "summary": "Suggestions for future actions.",
                "body": "Recommendations for leveraging SmartSeal's unique features and pursuing strategic opportunities.",
                "subsections": {
                    "6.1": {
                        "title": "Technical Differentiation",
                        "summary": "Recommendations for maintaining innovation.",
                        "body": "Focus on continuous improvement of sensory capabilities and modular design to stay ahead of competitors."
                    },
                    "6.2": {
                        "title": "Suggested Filing Strategy",
                        "summary": "Recommendations for filing patents.",
                        "body": "Adopt a phased filing strategy starting with the core regions of the United States, Europe, Japan, and South Korea, and expand based on market feedback."
                    },
                    "6.3": {
                        "title": "Final Patentability Snapshot",
                        "summary": "Snapshot of the patentability assessment.",
                        "body": "| Element | Novelty | Prior Art Risk | Strategic Value | Filing Recommendation |\n|---|---|---|---|---|\n| SmartSeal | High | Low | High | Strongly Recommended |"
                    }
                }
            }
        }
    },
      filename_url: {
        "ConnectivityStack_Overview.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
  ],
};

export const patentFileWrapperAgent = {
  conversations: [
    {
      id: 6067,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message: "",
      assistant_message:`Let’s start with your focus. What would you like to examine?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:05:31.907505",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:"A specific granted patent — US11345678B2",
      assistant_message:`What’s your goal — claim tracking, examiner behavior, or strategic arguments?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:`I want to see how the claims were amended`,
      assistant_message:`Should I track how claim language changed — especially for independent claims?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:`Yes, I want a before/after view of each amendment`,
      assistant_message:`Should I highlight examiner strategies — how often they allow, what rejections they repeat, and what arguments tend to work?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:`Yes, especially across similar tech domains`,
      assistant_message: `If the patent is part of a family, would you like to see how the same tech fared elsewhere — like in continuations or overseas filings?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
    {
      id: 6068,
      user_id: "272",
      thread_id: "1530",
      step: 1,
      user_message:`Yes, compare related U.S. and EPO filings`,
      assistant_message:`Should I focus on office actions, responses, amendments, examiner interviews, appeals — or show everything?`,
      json_datasources: {},
      json_report: {},
      filename_url: {},
      created_at: "2025-05-08T04:07:05.540176",
    },
   
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `Rejections and applicant arguments only`,
      assistant_message: "Are we looking at U.S. only, or also EPO, WIPO, JPO, etc.? Any time range to consider?",
      json_datasources: {},
      json_report: {},
      filename_url: {
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
    {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `USPTO and EPO — last 5 years`,
      assistant_message:"",
      json_datasources: {},
      json_report: {},
      filename_url: {
      },
      "json_response": sampleKeywords,
      created_at: "2025-05-06T08:20:37.592505",
    },
     {
      id: 6105,
      user_id: "272",
      thread_id: "1538",
      step: 2,
      user_message: `Continue`,
      assistant_message:

      "Almost there! The final stencil of your report is ready in the right pane. Review, add or modify sections as needed before final submission.",
      json_datasources: {},
      json_report: {
        "sections": {
            "0": {
                "title": "Invention Disclosure Analysis",
                "summary": "Overview of the disclosed invention and its core components.",
                "body": "",
                "subsections": {
                    "0.1": {
                        "title": "Invention Title",
                        "summary": "The name of the invention.",
                        "body": "SmartSeal – Modular Sensor-Enabled Packaging System"
                    },
                    "0.2": {
                        "title": "Core Problem and Target Audience",
                        "summary": "Problems addressed and intended users of the invention.",
                        "body": "The core problem addressed by SmartSeal is inefficiencies in packaging freshness and logistics. The target audience includes supply chain managers and manufacturers looking to track product integrity."
                    },
                    "0.3": {
                        "title": "High-Level System Workflow",
                        "summary": "Overview of how the system works.",
                        "body": "Input: Reusable sensor-enabled closure. Transformation: Monitors environmental conditions (e.g., temperature, humidity), tracks data related to product integrity. Output: Sends alerts if conditions deviate from optimal, generates reports on product freshness and logistics."
                    },
                    "0.4": {
                        "title": "Technical Novelty Details",
                        "summary": "Unique aspects of the invention.",
                        "body": "The SmartSeal features a reusable closure integrated with sensors. It combines modularity, real-time sensing, and plug-and-play deployment. Unlike basic sensor caps and track-and-trace platforms, SmartSeal integrates all these features for use in industrial settings."
                    },
                    "0.5": {
                        "title": "Known Similar Solutions",
                        "summary": "Existing solutions and their comparison.",
                        "body": "Overlaps: Basic sensor caps exist and there are a few track-and-trace platforms. Differences and Advantages: SmartSeal combines modularity, real-time sensing, and plug-and-play deployment, specifically designed for industrial settings, which is not typically addressed by existing solutions."
                    },
                    "0.6": {
                        "title": "Commercialization & IP Strategy",
                        "summary": "Regions targeted for commercialization and protection strategy.",
                        "body": "Countries/Regions for Commercialization and Protection: United States, Europe, Japan, South Korea. Protection Strategy: Focus on regional rollouts in the specified areas."
                    }
                }
            },
            "1": {
                "title": "Report Objective",
                "summary": "Goal of the report.",
                "body": "This report aims to analyze the SmartSeal invention in detail, evaluating its novelty, potential overlaps with existing solutions, and strategies for commercialization and IP protection.",
                "subsections": {}
            },
            "2": {
                "title": "Search Methodology",
                "summary": "Method used for the search.",
                "body": "A thorough search was conducted using relevant databases and keywords to identify existing solutions and literature related to sensor-enabled packaging systems.",
                "subsections": {
                    "2.1": {
                        "title": "Keywords Used",
                        "summary": "Keywords applied during the search process.",
                        "body": "Keywords used during the search process included sensor-enabled closure, real-time monitoring, data tracking, modularity, industrial settings, Arduino, reusable packaging, and plug-and-play deployment."
                    }
                }
            },
            "3": {
                "title": "Prior Art Search Analysis",
                "summary": "Analysis of prior art.",
                "body": "The analysis involved comparing SmartSeal to existing solutions, focusing on its unique features and potential overlaps.",
                "subsections": {
                    "3.1": {
                        "title": "Summary Table",
                        "summary": "Table summarizing the prior art search.",
                        "body": "A table was created to summarize the findings of the prior art search, highlighting key differences and similarities with existing solutions."
                    },
                    "3.2": {
                        "title": "Claims Comparison Chart",
                        "summary": "Comparison of the claims.",
                        "body": "A chart was used to compare the claims of SmartSeal against other similar inventions, showing the unique aspects and potential overlaps."
                    }
                }
            },
            "4": {
                "title": "Citation Analysis",
                "summary": "Analysis of citations.",
                "body": "An analysis of backward and forward citations was conducted to understand the impact and relevance of the SmartSeal invention.",
                "subsections": {
                    "4.1": {
                        "title": "Backward Citations",
                        "summary": "Review of prior patents cited by SmartSeal.",
                        "body": "Backward citations include key patents and literature that have influenced the development of SmartSeal."
                    },
                    "4.2": {
                        "title": "Forward Citations",
                        "summary": "Analysis of subsequent patents citing SmartSeal.",
                        "body": "Forward citations include patents and publications that have referenced SmartSeal, indicating its influence on subsequent innovations."
                    },
                    "4.3": {
                        "title": "Citation Network Visualization",
                        "summary": "Visual representation of citation relationships.",
                        "body": "A visual network was created to illustrate the relationships between SmartSeal and other patents through citations."
                    },
                    "4.4": {
                        "title": "Observations",
                        "summary": "Key takeaways from the citation analysis.",
                        "body": "The citation analysis reveals SmartSeal's strong influence on subsequent innovations and its reliance on prior foundational patents."
                    }
                }
            },
            "5": {
                "title": "Optional Add-Ons",
                "summary": "Additional analysis and insights.",
                "body": "Further analysis and insights that may provide additional value.",
                "subsections": {
                    "5.1": {
                        "title": "Visual Comparison Table",
                        "summary": "Visual table comparing SmartSeal to existing solutions.",
                        "body": "A visual comparison table was created to highlight the unique features and advantages of SmartSeal compared to existing solutions."
                    },
                    "5.2": {
                        "title": "Market Landscape Mapping",
                        "summary": "Analysis of the market landscape.",
                        "body": "The market landscape analysis maps out the competitive environment and identifies key players and potential opportunities for SmartSeal."
                    }
                }
            },
            "6": {
                "title": "Strategic Recommendations",
                "summary": "Suggestions for future actions.",
                "body": "Recommendations for leveraging SmartSeal's unique features and pursuing strategic opportunities.",
                "subsections": {
                    "6.1": {
                        "title": "Technical Differentiation",
                        "summary": "Recommendations for maintaining innovation.",
                        "body": "Focus on continuous improvement of sensory capabilities and modular design to stay ahead of competitors."
                    },
                    "6.2": {
                        "title": "Suggested Filing Strategy",
                        "summary": "Recommendations for filing patents.",
                        "body": "Adopt a phased filing strategy starting with the core regions of the United States, Europe, Japan, and South Korea, and expand based on market feedback."
                    },
                    "6.3": {
                        "title": "Final Patentability Snapshot",
                        "summary": "Snapshot of the patentability assessment.",
                        "body": "| Element | Novelty | Prior Art Risk | Strategic Value | Filing Recommendation |\n|---|---|---|---|---|\n| SmartSeal | High | Low | High | Strongly Recommended |"
                    }
                }
            }
        }
    },
      filename_url: {
        "ConnectivityStack_Overview.docx":
          "https://reportmanualdata.blob.core.windows.net/agents/frontend_272_2025-05-06-08-20-14_/1.%20EcoTech%20Innovations.pptx",
      },
      created_at: "2025-05-06T08:20:37.592505",
    },
  ],
};

